import { useEffect, useState, useRef } from "react"
import { READ_SINGLETL, UPDATE_TLCOUPLEIMG1, UPDATE_TLCOUPLEIMG2, GET_TLS3PRESIGNEDURL, REMOVE_TLCOMP, SAVE_TL, UPDATE_TLONEIM, READ_TLSPROJ, } from "../../../../../config/api"
import { iconwrapper, Retrieve_personal_info } from "../../../../../config/commonfunctions"
import { Banners, Checkdevice, Imagedownsize, Leftrightbtn, Loading, Modcfm, Noti, Portalmodal, refresh } from "../../../../../components"
import { ARROWLEFT_ICON, ENGLISH_FF, e_fs, ICONNAME_ICON_MAP, LOOKUPUNSTYLE_ICON, PLOBJ, WEBSITE_URL } from "../../../../../config/constants"
import { S3CLOUD_CLOUDFRONT, S3CLOUD_CLOUDFRONT_ASSET } from "../../../../../config/s3directories"
import { COLOR_ICON, FRAME_ICON, LAPTOP_ICON, DOWNLOAD_ICON, MOBILE_ICON, TRASH_ICON, GRID_ICON, RESIZE_ICON, ITINERARYTEMPLATE_ICON, ITINERARYCOMP_ICON, PRINT_ICON, COPY_ICON, ENTER_ICON, TEMPLATE_ICON, PLANNING_QR_ICON, TABLET_ICON } from "../../../../../config/svgicons"
import { Togglebutton } from "../../../../../basic_components"
import { multiplechoice_dom, partialtitle_dom, textarea_dom, inputdescribe_dom, radiobtn_dom, input_dom, checkbox_dom } from "../../Invitationmaker/components/Commonelements/Commonelements"
import { HexColorInput, HexColorPicker } from "react-colorful"
import { bannernames, banners, corners_banners_corners } from "../../../../../assets/invitationcard/index1"
import { Link } from 'react-router-dom'
import Itinerarylookup from "../../../../Itinerarylookup/Itinerarylookup"
import axios from 'axios'
import html2canvas from "html2canvas"
import { changeDpiBlob } from "changedpi"
import './Itineraryedit.css'
import { getPresignedUrlWithToken, notifyBackendUpload, uploadToS3 } from "../../../../../config/uploadimgapis"

export const couple1 = S3CLOUD_CLOUDFRONT_ASSET + "tl/classab10123.8097526711624771582975"
export const couple2 = S3CLOUD_CLOUDFRONT_ASSET + "tl/classab10123.3682746001617776634978"

const s_ = { width: 30, height: 40, verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }
const vb_ = "0 0 1024 1024"
const v_ = "1.1"
const x_ = "http://www.w3.org/2000/svg"

const MIN_ZOOM = 0.1;
const MAX_ZOOM = 3;
const ZOOM_STEP = 0.1;

const BANNER_SELECT_CSS = '3px solid #eb5d7b'
const BANNER_UNSELECT_CSS = '1px solid #707070'

const txtarea_css = { marginLeft: 0, marginRight: 0, width: '100%', margin: 0, padding: '0px 10px' }

function copyToClipboard(string) {
    let textarea;
    let result;

    try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', true);
        textarea.setAttribute('contenteditable', true);
        textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
        textarea.value = string;

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
    } catch (err) {
        console.error(err);
        result = null;
    } finally {
        document.body.removeChild(textarea);
    }

    // manual copy fallback using prompt
    if (!result) {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
        if (!result) {
            return false;
        }
    }
    return true;
}


const TEMPLATE_CONTENT = {
    'Templates': [
        {
            title: 'Wedding GDL',
            description: '',
            bgcolor: '#fffff8',
            data: [{ "component": "TEXT", "content": "Jermone & Alice", "fontStyle": "normal", "fontWeight": "bold", "fontFamily": "Lobster", "textAlign": "center", "url": "", "color": "#333333", "device": { "W": { "fontSize": 52, "marginBottom": 25, "marginTop": 25 }, "T": { "fontSize": 52, "marginBottom": 25, "marginTop": 25 }, "M": { "fontSize": 49, "marginBottom": 25, "marginTop": 25 }, "P": { "fontSize": 59, "marginBottom": 25, "marginTop": 25 } } }, { "component": "TEXT", "content": "过大礼", "fontStyle": "italic", "fontWeight": "bold", "fontFamily": "", "textAlign": "center", "url": "", "color": "#333333", "device": { "W": { "fontSize": 35, "marginBottom": 0, "marginTop": 0 }, "T": { "fontSize": 35, "marginBottom": 0, "marginTop": 0 }, "M": { "fontSize": 30, "marginBottom": 0, "marginTop": 0 }, "P": { "fontSize": 35, "marginBottom": 10, "marginTop": 0 } } }, { "component": "TEXT", "content": "17 / 09 / 2023", "fontStyle": "normal", "fontWeight": "bold", "fontFamily": "Cinzel", "textAlign": "center", "url": "", "color": "#333333", "device": { "W": { "fontSize": 35, "marginBottom": 10, "marginTop": 10 }, "T": { "fontSize": 35, "marginBottom": 10, "marginTop": 10 }, "M": { "fontSize": 35, "marginBottom": 0, "marginTop": 15 }, "P": { "fontSize": 28, "marginBottom": 15, "marginTop": 5 } } }, { "component": "BANNER", "url": `${S3CLOUD_CLOUDFRONT_ASSET}floral/Amaryllis_Purpurea/banner/banner.png`, "device": { "W": { "paddingTop": 30, "paddingBottom": 30, "paddingLeft": 0, "paddingRight": 26 }, "T": { "paddingTop": 30, "paddingBottom": 30, "paddingLeft": 0, "paddingRight": 26 }, "M": { "paddingTop": 20, "paddingBottom": 20, "paddingLeft": 0, "paddingRight": 0 }, "P": { "paddingTop": 0, "paddingBottom": 0, "paddingLeft": 0, "paddingRight": 27 } } }, { "component": "TIMELINE", "size": 1, "mode": 0, "title": { "value": "Morning Preparation ", "fontFamily": "Marck Script", "color": "#ff6d6d", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "bold", "device": { "W": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 25, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 25, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 } } }, "content": { "value": "- Makeup artist arrives at 6:30 AM.\n\n- Bridesmaids arrive at 7:00 AM to assist with morning preparation.\n\n- Bride's makeup and hair styling session.\n\n- Bridesmaids help with dressing the bride in her traditional wedding attire.", "fontFamily": "Lato", "color": "#333333", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 16, "marginTop": 10, "marginBottom": 30, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 14, "marginTop": 10, "marginBottom": 40, "marginLeft": 5, "marginRight": 40 } } }, "time": { "value": "6:00 AM", "fontFamily": "Lato", "color": "#333333", "justifyContent": "end", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "T": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "M": { "fontSize": 16, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 }, "P": { "fontSize": 18, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 } } }, "icon": { "state": true, "value": "M903.631412 792.763706H118.092711c-15.461511 0-28.033021-12.535384-28.03302-28.105271a28.033021 28.033021 0 0 1 28.03302-28.03302h785.538701c15.497636 0 28.033021 12.535384 28.03302 28.03302 0 15.569886-12.571509 28.105271-28.03302 28.105271z m-56.138291-325.052988a27.93187 27.93187 0 0 1-39.665279 0c-10.945883-10.945883-10.945883-28.647146 0-39.665279l39.665279-39.66528a28.061921 28.061921 0 0 1 39.665279 0c10.945883 11.018133 10.945883 28.719396 0 39.66528l-39.665279 39.665279z m-62.171171 212.81253c-26.082269-127.918719-138.683977-224.372539-274.441826-224.372539s-248.395682 96.453821-274.369576 224.372539H177.44613c21.530516-158.155366 162.454244-280.51083 333.433994-280.51083s311.903478 122.31934 333.433994 280.51083h-58.992168z m-274.441826-336.649121c-15.497636 0-28.033021-12.535384-28.03302-28.033021V259.702815a28.033021 28.033021 0 0 1 56.066041 0v56.138291c-0.036125 15.497636-12.571509 28.033021-28.033021 28.033021z m-336.649121 123.836591l-39.665279-39.665279c-10.945883-10.945883-10.945883-28.647146 0-39.66528a28.061921 28.061921 0 0 1 39.665279 0l39.665279 39.66528c10.945883 11.018133 10.945883 28.719396 0 39.665279a27.93187 27.93187 0 0 1-39.665279 0z", "color": "#000000" } }, { "component": "TIMELINE", "size": 1, "mode": 0, "title": { "value": "Gatecrash", "fontFamily": "Marck Script", "color": "#ff6d6d", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "bold", "device": { "W": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 25, "marginTop": 10, "marginBottom": 10, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 25, "marginTop": 10, "marginBottom": 10, "marginLeft": 5, "marginRight": 5 } } }, "content": { "value": "- Groom and groomsmen gather at the groom's location.\n\n- Bridesmaids prepare the gatecrash activities and games.\n\n- Groom and groomsmen travel to the bride's house for the gatecrash.", "fontFamily": "Lato", "color": "#333333", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 16, "marginTop": 10, "marginBottom": 30, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 15, "marginTop": 10, "marginBottom": 40, "marginLeft": 5, "marginRight": 40 } } }, "time": { "value": "9:00 AM", "fontFamily": "Lato", "color": "#333333", "justifyContent": "end", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 16, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 }, "P": { "fontSize": 18, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 } } }, "icon": { "state": true, "value": "M288 464h-32v-32h32v32z m160-104v560c0 22-18 40-40 40H232c-22 0-40-18-40-40V360c0-19.8 14.6-36.3 33.5-39.5V216c0-2.3 0.2-4.7 0.6-7.2 0.1-0.8 0.3-1.7 0.5-2.5 0.7-3.4 1.8-7 3.1-10.7 4.8-13.1 13.4-27.8 24.3-42.6 2.3-3.2 4.8-6.3 7.3-9.5 6.8-8.4 14.2-16.7 22.1-24.6 2-2 4-3.9 6-5.8 3-2.9 6.1-5.7 9.2-8.4 2.1-1.8 4.1-3.6 6.2-5.3 4.2-3.5 8.4-6.7 12.6-9.8 3.2-2.3 6.4-4.5 9.5-6.6 18-11.6 35.7-18.9 50.5-18.9 22 0 40 18 40 40v217.1c17.5 4.2 30.6 20.1 30.6 38.8z m-190.5-40h128V104c0-4.3-3.7-8-8-8-13.6 0-43.4 16.5-74 48.1-13.9 14.3-26.2 30-34.6 44.1-9 15-11.3 24.5-11.3 27.8v104zM416 920V464h-95v-32h95v-72c0-4.3-3.7-8-8-8H232c-4.3 0-8 3.7-8 8v560c0 4.3 3.7 8 8 8h176c4.3 0 8-3.7 8-8z m376-216h-72V448h-32v256h-72c-22 0-40 18-40 40v176c0 22 18 40 40 40h176c22 0 40-18 40-40V744c0-22-18-40-40-40z m8 216c0 4.3-3.7 8-8 8H616c-4.3 0-8-3.7-8-8V744c0-4.3 3.7-8 8-8h176c4.3 0 8 3.7 8 8v176z m-47.9-688.6h-96v-32h96v32z m0-66.9h-96v-32h96v32z m0 267.5h-96v-32h96v32z m-16-334.3h-64v-32h64v32z m16 200.6h-96v-32h96v32z m0 66.8h-96v-32h96v32z", "color": "#333333" } }, { "component": "TIMELINE", "size": 1, "mode": 0, "title": { "value": "Tea Ceremony\n", "fontFamily": "Marck Script", "color": "#ff6d6d", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "bold", "device": { "W": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 25, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 0 }, "P": { "fontSize": 25, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 0 } } }, "content": { "value": "- Relatives and friends start arriving at the bride's house for the tea ceremony.\n\n- Bridesmaids assist with the tea ceremony preparations.\n\n- The bride and groom serve tea to their parents and senior family members.", "fontFamily": "Lato", "color": "#333333", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 16, "marginTop": 10, "marginBottom": 30, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 14, "marginTop": 10, "marginBottom": 40, "marginLeft": 5, "marginRight": 40 } } }, "time": { "value": "9:00 AM", "fontFamily": "Lato", "color": "#333333", "justifyContent": "end", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "T": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "M": { "fontSize": 16, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 }, "P": { "fontSize": 18, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 } } }, "icon": { "state": true, "value": "M830.438563 406.554436l-45.588291 0 0-14.005992c0-33.098839-26.928303-60.027142-60.027142-60.027142L124.554784 332.521303c-33.098839 0-60.027142 26.928303-60.027142 60.027142l0 188.083679c0 91.385337 35.920094 185.921433 98.55155 259.367189 66.428945 77.902254 152.231123 120.803343 241.599524 120.803343l40.017412 0c89.369424 0 175.170578-42.902112 241.600547-120.803343 42.819225-50.212612 73.14388-110.284779 88.050382-172.468027l56.090483 0c71.951729 0 130.48996-58.537208 130.48996-130.487913C960.928522 465.091644 902.391315 406.554436 830.438563 406.554436zM655.847176 814.033941c-58.70196 68.838831-133.690862 106.750279-211.150024 106.750279l-40.017412 0c-77.460186 0-152.448064-37.911448-211.150024-106.750279-56.55097-66.316381-88.983637-151.387919-88.983637-233.401818l0-188.083679c0-11.033287 8.975419-20.008706 20.008706-20.008706l126.699634 0 0 97.419773-73.886801 0c-11.050684 0-20.008706 8.958022-20.008706 20.008706l0 190.085266c0 11.050684 8.958022 20.008706 20.008706 20.008706L367.452883 700.06219c11.050684 0 20.008706-8.958022 20.008706-20.008706L387.461589 489.968218c0-11.050684-8.958022-20.008706-20.008706-20.008706l-76.289524 0 0-97.419773 433.659771 0c11.032264 0 20.008706 8.975419 20.008706 20.008706l0 34.014698 0 154.068981C744.831836 662.647045 712.400193 747.717559 655.847176 814.033941zM347.444177 509.976924l0 150.066831L197.377346 660.043754 197.377346 509.976924 347.444177 509.976924zM830.438563 627.513874l-45.588291 0 0-46.88175L784.850272 446.572872l45.588291 0c49.885154 0 90.471524 40.585347 90.471524 90.471524C920.91111 586.92955 880.32474 627.513874 830.438563 627.513874zM245.986437 162.269757c0.76748 0.665149 18.817578 16.601096 18.817578 44.189432 0 14.413268-3.50687 21.300119-8.362458 30.832216-5.506411 10.810207-12.360516 24.26566-12.360516 46.989197 0 11.050684 8.958022 20.008706 20.008706 20.008706 11.050684 0 20.008706-8.958022 20.008706-20.008706 0-13.117762 3.356444-19.706831 8.000208-28.826536 5.668093-11.128455 12.721743-24.975834 12.721743-48.994877 0-46.855144-31.787984-73.745584-33.141818-74.867128 0 0-15.661701-15.129582-27.598568-4.605901-17.507746 15.435551 2.059915 35.414581 2.059915 35.414581L245.986437 162.269757zM434.128445 234.942917c0 38.401612-29.996175 54.088896-31.101345 54.653761 0 0-19.268856 13.372565-10.128685 29.04757 9.140171 15.676028 27.550473 6.977925 27.550473 6.977925 2.191922-1.060145 53.699016-26.703175 53.699016-90.680279 0-31.127951-16.331967-49.709145-29.452799-64.639183-10.538007-11.990079-16.499789-19.266809-16.499789-29.399587 0-31.937386 14.552437-37.551244 15.172561-37.773302-0.524956 0.188288-0.828878 0.23536-0.828878 0.23536s22.959921-9.784854 18.339694-28.264741c-4.620227-18.479887-28.138874-10.534937-28.138874-10.534937-16.550954 4.180206-44.562938 24.962531-44.562938 76.337619 0 25.712615 14.670118 42.405809 26.458605 55.818283C426.721755 210.473619 434.128445 219.675188 434.128445 234.942917zM551.793308 162.40074c0.187265 0.155543 18.665105 16.249079 18.665105 44.058448 0 14.413268-3.507894 21.300119-8.363482 30.832216-5.506411 10.810207-12.359492 24.26566-12.359492 46.989197 0 11.050684 8.959046 20.008706 20.008706 20.008706 11.04966 0 20.008706-8.958022 20.008706-20.008706 0-13.117762 3.355421-19.706831 8.001231-28.826536 5.66707-11.128455 12.720719-24.975834 12.720719-48.994877 0-46.855144-31.79003-73.745584-33.143864-74.867128-8.507768-7.055696-21.123087-5.870708-28.17469 2.635013C542.104645 142.734842 543.28554 155.349137 551.793308 162.40074z", "color": "#333333" } }, { "component": "TIMELINE", "size": 1, "mode": 0, "title": { "value": "Photoshoot", "fontFamily": "Marck Script", "color": "#ff6d6d", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "bold", "device": { "W": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 25, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 0 }, "P": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 } } }, "content": { "value": "- Bride, groom, and bridal party proceed to the photoshoot location.\n\n- Bridesmaids and groomsmen provide support and assistance during the photoshoot.\n\n- Capturing memorable moments.", "fontFamily": "Lato", "color": "#333333", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 16, "marginTop": 10, "marginBottom": 30, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 } } }, "time": { "value": "10:30 AM", "fontFamily": "Lato", "color": "#333333", "justifyContent": "end", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "T": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "M": { "fontSize": 16, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 }, "P": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 } } }, "icon": { "state": true, "value": "M576 368H448c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v144c0 8.8-7.2 16-16 16z m-112-32h96V224H464v112zM553.6 480.8H470.4c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16h83.2c8.8 0 16 7.2 16 16v112c0 9.6-7.2 16.8-16 16.8z m-67.2-32h51.2V368h-51.2v80.8zM658.4 224H349.6c-8.8 0-16-7.2-16-16V40.8c0-8.8 7.2-16 16-16h308.8c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16z m-292.8-32h276.8V56.8H365.6V192zM291.2 140.8H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.4c8.8 0 16 7.2 16 16s-6.4 16-15.2 16zM226.4 244.8c-6.4 0-12.8-4-15.2-10.4-3.2-8 0.8-17.6 8.8-20.8l62.4-24c8-3.2 17.6 0.8 20.8 8.8 3.2 8-0.8 17.6-8.8 20.8l-62.4 24c-1.6 1.6-3.2 1.6-5.6 1.6zM288.8 60c-1.6 0-4 0-5.6-0.8l-62.4-24c-8-3.2-12-12.8-8.8-20.8 3.2-8 12.8-12 20.8-8.8l62.4 24c8 3.2 12 12.8 8.8 20.8-3.2 6.4-8.8 9.6-15.2 9.6zM783.2 140.8h-66.4c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.4c8.8 0 16 7.2 16 16s-7.2 16-16 16zM719.2 60c-6.4 0-12.8-4-15.2-10.4-3.2-8 0.8-17.6 8.8-20.8l62.4-24c8-3.2 17.6 0.8 20.8 8.8 3.2 8-0.8 17.6-8.8 20.8l-62.4 24c-1.6 1.6-4 1.6-5.6 1.6zM780.8 244.8c-1.6 0-4 0-5.6-0.8l-62.4-24c-8-3.2-12-12.8-8.8-20.8 3.2-8 12.8-12 20.8-8.8l62.4 24c8 3.2 12 12.8 8.8 20.8-2.4 5.6-8.8 9.6-15.2 9.6zM860 1020h-696c-41.6 0-76-34.4-76-76V618.4c0-41.6 34.4-76 76-76h696.8c41.6 0 76 34.4 76 76V944c-0.8 41.6-34.4 76-76.8 76z m-696-445.6c-24 0-44 20-44 44V944c0 24 20 44 44 44h696.8c24 0 44-20 44-44V618.4c0-24-20-44-44-44H164zM664 574.4H360c-5.6 0-10.4-2.4-13.6-7.2-3.2-4.8-3.2-10.4-1.6-15.2l41.6-93.6c2.4-5.6 8-9.6 14.4-9.6h221.6c6.4 0 12 4 14.4 9.6L678.4 552c2.4 4.8 1.6 10.4-1.6 15.2-2.4 4-7.2 7.2-12.8 7.2z m-280-32h256L612 480h-200L384 542.4zM284 574.4H177.6c-8.8 0-16-7.2-16-16v-65.6c0-8.8 7.2-16 16-16h105.6c8.8 0 16 7.2 16 16v65.6c0.8 8.8-6.4 16-15.2 16z m-90.4-32h73.6v-33.6h-73.6v33.6zM295.2 936c-4.8 0-8-3.2-8-8V633.6c0-4.8 3.2-8 8-8s8 3.2 8 8V928c0 4.8-3.2 8-8 8zM603.2 956.8c-96.8 0-175.2-78.4-175.2-175.2s78.4-175.2 175.2-175.2 175.2 78.4 175.2 175.2-78.4 175.2-175.2 175.2z m0-335.2c-88 0-159.2 71.2-159.2 159.2 0 88 71.2 159.2 159.2 159.2s159.2-71.2 159.2-159.2c0.8-88-71.2-159.2-159.2-159.2zM690.4 788.8c-4.8 0-8-3.2-8-8 0-44-36-79.2-79.2-79.2-4.8 0-8-3.2-8-8s3.2-8 8-8c52.8 0 95.2 43.2 95.2 95.2 0 4.8-3.2 8-8 8z", "color": "#333333" } }, { "component": "TIMELINE", "size": 1, "mode": 0, "title": { "value": "Solemnisation", "fontFamily": "Marck Script", "color": "#ff6d6d", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "bold", "device": { "W": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 25, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 0 }, "P": { "fontSize": 24, "marginTop": 5, "marginBottom": 0, "marginLeft": 5, "marginRight": 5 } } }, "content": { "value": "- Bridesmaids and groomsmen report to their respective sides.\n\n- Bridesmaids assist the bride with her gown and bouquet.\n\n- Groom and groomsmen participate in the solemnization ceremony.", "fontFamily": "Lato", "color": "#333333", "justifyContent": "center", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "T": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 }, "M": { "fontSize": 16, "marginTop": 10, "marginBottom": 30, "marginLeft": 5, "marginRight": 5 }, "P": { "fontSize": 16, "marginTop": 10, "marginBottom": 50, "marginLeft": 5, "marginRight": 5 } } }, "time": { "value": " 12:30 PM", "fontFamily": "Lato", "color": "#333333", "justifyContent": "end", "fontStyle": "normal", "fontWeight": "normal", "device": { "W": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "T": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 }, "M": { "fontSize": 16, "marginBottom": 10, "marginTop": 10, "marginLeft": 0, "marginRight": 5 }, "P": { "fontSize": 18, "marginTop": 10, "marginBottom": 10, "marginLeft": 0, "marginRight": 5 } } }, "icon": { "state": true, "value": "M93.6 1020c-4 0-8-1.6-11.2-4.8l-63.2-62.4c-3.2-3.2-4.8-7.2-4.8-11.2 0-4 1.6-8 4.8-11.2l40.8-40.8-40.8-40.8c-6.4-6.4-6.4-16 0-22.4l63.2-62.4c3.2-3.2 7.2-4.8 11.2-4.8 4 0 8 1.6 11.2 4.8l40 40 14.4-14.4c-87.2-127.2-72-302.4 36.8-412 60.8-60.8 141.6-94.4 227.2-94.4 47.2 0 92.8 10.4 136 29.6 8 4 11.2 13.6 8 21.6-4 8-13.6 11.2-21.6 8-38.4-17.6-79.2-27.2-122.4-27.2-77.6 0-149.6 30.4-204.8 84.8C116.8 502.4 105.6 665.6 192 780.8c4.8 6.4 4 15.2-1.6 20.8l-35.2 36c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-40-40-40 40 40.8 40.8c6.4 6.4 6.4 16 0 22.4l-40.8 40.8 40 40 40-40c6.4-6.4 16.8-6.4 22.4 0l40 40 40-40-40.8-40.8c-6.4-6.4-6.4-16 0-22.4l36-36c5.6-5.6 14.4-6.4 20.8-1.6 49.6 36.8 108.8 56 170.4 56 77.6 0 149.6-30.4 204.8-84.8 110.4-110.4 112-292.8 4.8-406.4-6.4-6.4-5.6-16.8 0.8-22.4 8-7.2 17.6-7.2 24-0.8 119.2 125.6 117.6 328-4.8 450.4C590.4 894.4 509.6 928 424 928c-64 0-125.6-18.4-178.4-54.4l-15.2 15.2 40.8 40.8c6.4 6.4 6.4 16 0 22.4l-63.2 62.4c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-40-40-40 40c-4 4-8 5.6-12 5.6zM688.8 924.8c-45.6 0-89.6-9.6-131.2-28-8-4-12-12.8-8-20.8s12.8-12 20.8-8c37.6 16.8 76.8 25.6 118.4 25.6 159.2 0 289.6-130.4 289.6-290.4v-2.4C976 456 868.8 333.6 728 314.4c-8-0.8-13.6-8-13.6-16V190.4c0-6.4 4-12 9.6-14.4 6.4-2.4 12.8-0.8 17.6 3.2l42.4 42.4 40-40L686.4 42.4 547.2 181.6l40 40 42.4-42.4c4.8-4.8 11.2-5.6 17.6-3.2 5.6 2.4 9.6 8 9.6 14.4v108c0 8-5.6 14.4-13.6 16C503.2 336.8 400.8 456 399.2 599.2v2.4c0 74.4 28 144.8 79.2 199.2 6.4 6.4 5.6 16.8-0.8 22.4-6.4 6.4-16.8 5.6-22.4-0.8C398.4 762.4 368 684 368 601.6v-3.2c1.6-154.4 109.6-284 258.4-313.6v-56L599.2 256c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-63.2-62.4c-6.4-6.4-6.4-16 0-22.4L674.4 8.8c6.4-6.4 16.8-6.4 22.4 0l160.8 161.6c3.2 3.2 4.8 7.2 4.8 11.2 0 4-1.6 8-4.8 11.2L795.2 256c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-26.4-26.4v55.2c149.6 28 261.6 160 263.2 314.4v3.2c0 177.6-144 322.4-320.8 322.4zM650.4 832h-3.2l-3.2-0.8c-8.8-1.6-14.4-9.6-12.8-18.4 1.6-8.8 9.6-14.4 18.4-12.8l3.2 0.8c8.8 1.6 14.4 9.6 12.8 18.4-0.8 8-7.2 12.8-15.2 12.8zM688.8 828c-12 0-24.8-0.8-36.8-3.2l-2.4-0.8c-4-0.8-7.2-4.8-6.4-9.6 0.8-4 4.8-7.2 9.6-6.4l2.4 0.8c11.2 1.6 22.4 2.4 33.6 2.4 115.2 0 208.8-94.4 208.8-209.6 0-4.8 3.2-8 8-8s8 3.2 8 8c-0.8 124.8-101.6 226.4-224.8 226.4zM904.8 609.6c-4.8 0-8-3.2-8-8v-2.4c-1.6-114.4-95.2-207.2-208-207.2-47.2 0-92 16-129.6 45.6-49.6 40-78.4 98.4-79.2 161.6v2.4c0 4.8-3.2 8-8 8s-8-3.2-8-8v-3.2c0.8-68 32-131.2 84.8-173.6 40-32 88-48.8 140-48.8 122.4 0 223.2 100 224 223.2v3.2c0 4-3.2 7.2-8 7.2zM557.6 783.2c-1.6 0-3.2-0.8-4.8-1.6-56-43.2-88-108.8-88-179.2 0-4.8 3.2-8 8-8s8 3.2 8 8c0 65.6 29.6 126.4 82.4 166.4 3.2 2.4 4 8 1.6 11.2-2.4 1.6-4.8 3.2-7.2 3.2zM424 831.2c-60 0-116-23.2-158.4-66.4-88-88-88-231.2 0-319.2 42.4-42.4 98.4-66.4 158.4-66.4 13.6 0 27.2 1.6 40.8 4 4 0.8 7.2 4.8 6.4 9.6-0.8 4-4.8 7.2-9.6 6.4-12.8-2.4-25.6-3.2-38.4-3.2-56 0-108 21.6-147.2 61.6-81.6 81.6-81.6 215.2 0 296.8 39.2 39.2 92 61.6 147.2 61.6 56 0 108-21.6 147.2-61.6 81.6-81.6 81.6-215.2 0-296.8-5.6-6.4-12-12-19.2-16.8-3.2-2.4-4-8-1.6-11.2 2.4-3.2 8-4 11.2-1.6 7.2 5.6 13.6 12 20.8 18.4 88 88 88 231.2 0 319.2-41.6 42.4-98.4 65.6-157.6 65.6z", "color": "#000000" } }]
        },
        // {
        //     title: 'Church Wedding Itinerary',
        //     description: '',
        //     data: [],
        // },
        // {
        //     title: 'Wedding Lunch',
        //     description: '',
        //     data: [
        //         {
        //             "content": {
        //                 "value": "Arrive at the bride's home or designated venue for the Guo Da Li ceremony. Exchange warm greetings with the couple's families and friends."
        //             },
        //             "time": {
        //                 "value": "09:00am"
        //             },
        //             "title": {
        //                 "value": "Arrival and Greetings"
        //             }
        //         },
        //         {
        //             "content": {
        //                 "value": "Perform traditional Guo Da Li rituals, including the bride and groom offering gifts to each other's families and receiving blessings."
        //             },
        //             "time": {
        //                 "value": "09:30am"
        //             },
        //             "title": {
        //                 "value": "Guo Da Li Rituals"
        //             }
        //         },
        //         {
        //             "content": {
        //                 "value": "Enjoy a sumptuous breakfast or tea ceremony with the couple's families and close relatives."
        //             },
        //             "time": {
        //                 "value": "10:30am"
        //             },
        //             "title": {
        //                 "value": "Breakfast or Tea Ceremony"
        //             }
        //         },
        //         {
        //             "content": {
        //                 "value": "Capture memorable photos and videos to commemorate the Guo Da Li ceremony."
        //             },
        //             "time": {
        //                 "value": "11:30am"
        //             },
        //             "title": {
        //                 "value": "Photo and Video Session"
        //             }
        //         },
        //         {
        //             "content": {
        //                 "value": "Wrap up the Guo Da Li ceremony with heartfelt goodbyes and well wishes."
        //             },
        //             "time": {
        //                 "value": "12:30pm"
        //             },
        //             "title": {
        //                 "value": "Conclusion and Farewells"
        //             }
        //         }
        //     ],
        // },
    ],

}

function useLongPress() {
    return function (callback) {
        let timeout;
        let preventClick = false;

        function start() {
            timeout = setInterval(() => {
                preventClick = true;
                callback();
            }, 100);
        }

        function clear() {
            // Get a reference to the last interval + 1
            const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }

            timeout && clearInterval(timeout);
            preventClick = false;
        }

        function clickCaptureHandler(e) {
            if (preventClick) {
                e.stopPropagation();
                preventClick = false;
            }
        }

        return {
            onMouseDown: start,
            onTouchStart: start,
            onMouseUp: clear,
            onMouseLeave: clear,
            onTouchMove: clear,
            onTouchEnd: clear,
            onClickCapture: clickCaptureHandler
        };
    }
}

function Itineraryedit(props) {

    // default stuff
    const { token } = Retrieve_personal_info()
    const device = Checkdevice()
    const [loaded, setLoaded] = useState(false)
    const [returnhome, setReturnhome] = useState(false)

    // data
    const [id, setId] = useState('')
    const [urlhandler, setUrlhandler] = useState('')
    const [passcode, setPasscode] = useState('')
    const [bgcolor, setBgcolor] = useState('')
    const [tlobjs, setTlobjs] = useState([]) // array of objects , where each is a component. components are : TEXT, BANNER, TIMELINE, IMAGE, EMPTYSPACE
    const [maximgobj, setMaximgobj] = useState(-1) // total number of img compoenet allow in tlobjs MAX 3
    const [numimgobjs, setNumimgobjs] = useState(-1)

    // simulator device 
    const [simulatordevice, setSimulatordevice] = useState('W')// W,T, M, P

    // pringing size
    const [printingsize, setPrintingsize] = useState({ width: 0, height: 0 })

    // content - NONE, TEMPLATE, ADD, TEXT, BANNER, TIMELINE, IMAGE
    const [rightcontentkey, setRightcontentkey] = useState('NONE')

    // index of comp selected to edit
    const [selectededitindex, setSelectededitindex] = useState(-1)

    // index to add comp
    const [selectedaddindex, setSelectedaddindex] = useState(-1)

    // top or btm of selectedaddindex
    const [selectedadddirection, setSelectedadddirection] = useState('')

    // add component to top or btm of the selectededitindex - '', 'TOP', 'BTM'
    const [toporbtm, setToporbtm] = useState('')

    // selectedtlmenubtn, select menu Title, Content, Time
    const [selectedtlmenubtn, setSelectedtlmenubtn] = useState('Title')

    // icons portal
    const [iconportal, setIconportal] = useState(false)

    // delete btn
    const [delgate, setDelgate] = useState(false)

    // grid
    const [grid, setGrid] = useState(false)

    // download gate
    const [allowedit, setAllowedit] = useState(true)

    // frame 
    const [frame, setFrame] = useState(0)
    const [framecolor, setFramecolor] = useState('black')
    const [framecorner, setFramecorner] = useState(0)
    const [framethickness, setFramethickness] = useState(1)
    const [framestroke, setFramestroke] = useState('dashed')

    // save block
    const [blocksave, setBlocksave] = useState(false)
    const [notitxt, setNotitxt] = useState('')

    // new template replacement
    const [cfmaddnewtemplate, setCfaddnewtemplate] = useState(false)
    const [newtemplatedata, setNewtemplatedata] = useState([])

    // qr modal
    const [qrmodal, setQrmodal] = useState(false)

    // downloadmodal
    const [downloadmodal, setDownloadmodal] = useState(false)
    const [downloadsize, setDownloadsize] = useState('A3')
    const [downloadtransparent, setDownloadtransparent] = useState(false) // transparent if is true, for download
    const [downloadchart, setDownloadchart] = useState(false)

    // top corner image
    const [cornerimg, setCornerimg] = useState('')
    const [cornerimgindex, setCornerimgindex] = useState(-1)

    // to off the edit of component
    const [hover, setHover] = useState(false)

    const [copymode, setCopymode] = useState(false)

    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        if (copymode) {
            setTimeout(() => {
                setCopymode(false)
            }, [1500])
        }
    }, [copymode])

    const onLongPress = useLongPress();

    const couple1ref = useRef(null)

    const couple2ref = useRef(null)

    // retrieve itinerary data from urlhandler 
    useEffect(() => {
        props.hidetopbar(true)
        var id = props.match.params.id
        axios({
            method: 'POST',
            url: READ_SINGLETL,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { id }
        })
            .then((timeline) => {
                const { message, tl } = timeline.data
                if (message === 'SUCCESS') {
                    const {
                        urlhandler, passcode, tlobjs, maximgobj,
                        banner, bcolor, bgcolor, design, fcolor,
                        hearticon, imgs, mode, name,
                        startdate, user_id, _id,
                        frame, framethickness, framestroke, framecolor, framecorner,
                        printingsize, cornerimg

                    } = tl

                    setLoaded(true)

                    setUrlhandler(urlhandler)
                    setPasscode(passcode)
                    setBgcolor(bgcolor)
                    setTlobjs(tlobjs)
                    setMaximgobj(maximgobj)
                    setId(_id)
                    setFrame(frame)
                    setFramethickness(framethickness)
                    setFramestroke(framestroke)
                    setFramecolor(framecolor)
                    setFramecorner(framecorner)
                    setPrintingsize(printingsize)
                    setCornerimg(cornerimg)
                    let local_cornerindex = -1
                    for (let i = 0; i < corners_banners_corners.length; i++) {
                        const { corner } = corners_banners_corners[i]
                        if (corner[0] === cornerimg) {
                            local_cornerindex = i
                            break
                        }
                    }
                    setCornerimgindex(local_cornerindex)

                }
            }).catch((e) => {
                // props.history.push('/') 
            })

        return () => props.hidetopbar(false)

    }, [])

    useEffect(() => {
        let numimgobjs = 0
        for (let i = 0; i < tlobjs.length; i++) {
            if (tlobjs[i].component === 'IMAGE') {
                numimgobjs += 1
            }
        }
        setNumimgobjs(numimgobjs)
    }, [rightcontentkey])

    useEffect(() => {
        if (!downloadmodal) {
            setDownloadtransparent(false)
        }
    }, [downloadmodal])

    useEffect(() => {
        if (downloadchart) {
            setTimeout(() => {
                html2canvas(document.getElementById('Itinerarylookup_root'), {
                    allowTaint: false,
                    useCORS: true,
                    logging: true,
                    scrollX: 0,
                    scrollY: -window.scrollY,
                    backgroundColor: downloadtransparent ? null : bgcolor
                }).then(async (canvas) => {// download happens here
                    const link = document.createElement("a");
                    link.download = Math.random() + ".png";
                    document.body.appendChild(link);

                    canvas.toBlob(function (b) {
                        changeDpiBlob(b, 300)
                            .then(function (blob) {
                                // use your changed blob
                                link.href = window.URL.createObjectURL(blob);
                                link.click()
                                setAllowedit(true)
                                setDownloadchart(false)
                            })
                    });

                    document.body.removeChild(link);
                }).catch(e => { alert('Fail to download.') })
            }, 1000)
        }
    }, [downloadchart])

    const download_old = () => {

        setTimeout(() => {
            html2canvas(document.getElementById('Itinerarylookup_root'), {
                allowTaint: false,
                useCORS: true,
                logging: true,
                backgroundColor: 'white',
                scrollX: 0,
                scrollY: -window.scrollY,
            }).then(async (canvas) => {// download happens here
                const link = document.createElement("a");
                link.download = Math.random() + ".png";
                document.body.appendChild(link);

                canvas.toBlob(function (b) {
                    changeDpiBlob(b, 300)
                        .then(function (blob) {
                            // use your changed blob
                            link.href = window.URL.createObjectURL(blob);
                            link.click()
                            setAllowedit(true)
                        })
                });

                document.body.removeChild(link);
            }).catch(e => {
                alert('fail to download')
            })
        }, 1000)

    }

    const deletefunc = () => {
        setDelgate(!delgate)
    }

    const timersequence = (run, msg) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                setNotitxt(msg)  // SHOW THIS MSG FIRST
                setTimeout(() => { // after timeone, run will be executed.
                    run();
                    resolve(
                        {
                            'Saved': 'SUCCESS',
                            'Failed': 'FAILURE',
                            'Failed': 'ALRDY_EXIST',
                        }[msg]
                    ); // Resolve the promise when the timers are done
                }, 1250);
            }, 1250);
        });
    };
    const save = () => {
        setBlocksave(true)
        setNotitxt('Saving...')
        let options = {
            method: 'POST',
            url: SAVE_TL,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }, //need token from the web
            data: { tlobjs: tlobjs, _id: id, urlhandler: urlhandler, bgcolor: bgcolor, frame: frame, framethickness: framethickness, framecorner: framecorner, framecolor: framecolor, framestroke, cornerimg }
        }
        axios(options).then((result) => {
            const { data, status } = result
            const { message } = data
            if (status === 200) {
                timersequence(
                    () => {
                        setBlocksave(false)
                        if (message === 'SUCCESS') {
                            setNotitxt('')
                        }
                    },
                    {
                        'SUCCESS': 'Saved',
                        'FAILURE': 'Failed'
                    }[message]
                )
            }
        }).catch(e => { })

    }



    const preview = () => {
        document.getElementById('iepreview_btninvisible').click()
    }


    const copydom = copymode
        ? <div id='copy_dom' style={{ width: '100vw', position: 'absolute', placeContent: 'center', alignContent: 'center', left: 0, display: 'flex', bottom: 150, zIndex: 99999999999999 }}>
            <div style={{ display: 'flex', width: 200, height: 40, backgroundColor: 'var(--maindark)', color: '#ffffff', placeContent: 'center', alignContent: 'center', borderRadius: 5, position: 'fixed', alignItems: 'center' }}>Copied!</div>
        </div>
        : null

    const portalmidcss = { width: { 'WEB': 500, 'TABLET': 450, 'MOBILE': '100%' }[device], height: { 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device], backgroundColor: 'white', top: '50%', left: '50%', right: '', transform: 'translate(-50%,-50%)' }

    const qr_modal = <Portalmodal
        portaltype={'commonportal'}
        open={qrmodal}
        onClose={() => { setQrmodal(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingdom={copydom}
        floatingclosecolor='#333333'
        title="QR Code"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">
                <p className="ie_modaltext" style={{ marginBottom: 15 }}>Printable version QR code for your guest during wedding that will automatically direct them to your timeline itinerary.</p>
                <div className="Details_grp" style={{ display: 'flex', flexDirection: 'row' }}>
                    {input_dom(
                        'Itinerary URL Handler',
                        '',
                        `${WEBSITE_URL}/timelinelookup/${urlhandler}/passcode=${passcode}`,
                        (e) => {
                        },
                        '',
                        {},
                        true,
                        null,
                        {},
                        { marginLeft: 0, marginRight: 0, width: '100%', margin: 0, }
                    )}
                    <button
                        className="planning_editbtn"
                        style={{}}
                        onClick={(e) => {
                            try {
                                var test = function (regexp) {
                                    return regexp.test(window.navigator.userAgent);
                                }

                                if (test(/safari/i)) { // is safari
                                    copyToClipboard(e.target.value)
                                }
                                else {
                                    navigator.clipboard.writeText(e.target.value)
                                }
                                setCopymode(true)

                            }
                            catch (e) {
                                console.log(e)
                            }
                        }}
                        value={`${WEBSITE_URL}/timelinelookup/${urlhandler}/passcode=${passcode}`}>
                        {iconwrapper(COPY_ICON, { borderRadius: 5, padding: 0, margin: 0, width: 20, height: 20, pointerEvents: 'none' })}
                    </button>
                </div>
                <div className="Details_grp" style={{ display: 'flex', flexDirection: 'row', placeContent: 'end' }}>
                    <Link id='qr_link' to="/tools/qr" target="_blank" style={{ visibility: 'hidden' }} />
                    <button
                        className='Ieditcomp_qr'
                        onClick={() => {
                            document.getElementById('qr_link').click()
                        }}
                    >
                        <div>QR App</div>
                        {iconwrapper(ENTER_ICON, { width: 24, height: 24, marginLeft: 5 })}
                    </button>
                </div>

            </div>
        </div>
    </Portalmodal>



    // top bar start
    const bar_wt_dom = <div style={{ width: '100%', borderBottom: '1px solid #dddddd', padding: 10, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1040 }}>
        <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center', pointerEvents: 'none', userSelect: 'none', opacity: 0 }}></div>
        <button className="planning_backicon" style={{ position: 'absolute', left: 10, }} onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
        <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center' }}></div>
        <div className="ie_previewbtn_root" style={{ position: 'relative', height: 'max-content', margin: 0, right: 0 }}>
            <button className="scedit_qrbtn" onClick={() => setQrmodal(true)}>{iconwrapper(PLANNING_QR_ICON, { width: 24, height: 24 })}</button>
            <button className="scedit_savingbtn" style={{ marginRight: 5 }} disabled={blocksave} onClick={save}>Save</button>
            <button className="iepreview_btn" style={{ margin: 0 }} onClick={preview}>
                {LOOKUPUNSTYLE_ICON} Preview
                <Link id="iepreview_btninvisible" to={'/timelinelookup/' + urlhandler + '/passcode=' + passcode} target="_blank" />
            </button>
        </div>
    </div>

    const bar_m_dom = <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
        <div style={{ width: '100%', padding: '0px 10px', height: 60, borderBottom: '1px solid #dddddd', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 'max-content', userSelect: 'none' }}>
            <button className="planning_backicon" onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
            <button className="iepreview_btn" style={{ margin: 0 }} onClick={() => { document.getElementById('iepreview_btninvisible').click() }}>
                {LOOKUPUNSTYLE_ICON} Preview
                <Link id="iepreview_btninvisible" to={'/timelinelookup/' + urlhandler + '/passcode=' + passcode} target="_blank" />
            </button>
        </div>
    </div>

    const topbar = { 'WEB': bar_wt_dom, 'TABLET': bar_wt_dom, 'MOBILE': bar_m_dom }[device]

    // home modcfm start
    const home_mod = returnhome
        ? <Modcfm
            onHide={() => { setReturnhome(false) }}
            onOk={() => { props.history.push(PLOBJ['itinerary']['toolurl']) }}
            onNo={() => { setReturnhome(false) }}
            txt={'You are returning to planning tools menu.'}
        /> : null

    // content start
    const left_template_or_add_dom_ = <div id='itineraryedit_leftcontentroot'>
        <button
            className='itineraryedit_leftbtn'
            value={'TEMPLATE'}
            onClick={(e) => {
                setRightcontentkey(e.target.value)
                setSelectededitindex(-1)
                setSelectedaddindex(-1)
            }}
        >
            Template
        </button>
        <div id='itineraryedit_or'>OR</div>
        <button
            className='itineraryedit_leftbtn'
            value={'ADD'}
            onClick={(e) => {
                setRightcontentkey(e.target.value)
                setSelectededitindex(-1)
                setSelectedaddindex(-1)
            }}>
            +
        </button>
    </div>

    const left_template_or_add_dom = <div id='itineraryedit_leftcontentroot' style={{ height: 'calc(100% - 90px)' }} >
        <button
            className='itineraryedit_startbtn'
            style={{ marginBottom: 10 }}
            value={'TEMPLATE'}
            onClick={(e) => {
                setRightcontentkey(e.target.value)
                setSelectededitindex(-1)
                setSelectedaddindex(-1)
            }}
        >
            {iconwrapper(ITINERARYTEMPLATE_ICON, { width: 32, height: 32, userSelect: 'none', pointerEvents: 'none' })}
            <div className="itineraryedit_startbtntxt">Template</div>
        </button>
        <button
            className='itineraryedit_startbtn'
            value={'ADD'}
            onClick={(e) => {
                setRightcontentkey(e.target.value)
                setSelectededitindex(-1)
                setSelectedaddindex(-1)
            }}
        >
            {iconwrapper(ITINERARYCOMP_ICON, { width: 32, height: 32, userSelect: 'none', pointerEvents: 'none' })}
            <div className="itineraryedit_startbtntxt">Component</div>
        </button>
    </div>

    const iconsize = { 'WEB': 30, 'TABLET': 25, 'MOBILE': 0 }[device]

    const alldevicesbtns = <Togglebutton
        singlebtnstyle={{ width: 40, height: 40 }}
        funcs={[
            () => setSimulatordevice('W'),
            () => setSimulatordevice('T'),
            () => setSimulatordevice('M'),
            () => setSimulatordevice('P') // print
        ]}
        txts={[
            iconwrapper(LAPTOP_ICON, { width: iconsize, height: iconsize }),
            iconwrapper(TABLET_ICON, { width: iconsize, height: iconsize }),
            iconwrapper(MOBILE_ICON, { width: iconsize, height: iconsize }),
            iconwrapper(PRINT_ICON, { width: iconsize, height: iconsize })
        ]}
        btnselected={{ 'W': 0, 'T': 1, 'M': 2, 'P': 3 }[simulatordevice]}
    />

    const left_dom = <div className={`itineraryedit_left itineraryedit_left${device} sketchbg`} onClick={() => setHover(!hover)}>
        <div className={`itineraryedit_devicebtns${device}`}>

            <div style={{ display: 'flex', flexDirection: 'row', width: 'calc((100% - 122px )/2)' }}>
                <button
                    className="itinerary_colorbtn"
                    style={grid ? { color: 'var(--mainpink)', marginLeft: 0 } : { color: 'var(--maindark)', marginLeft: 0 }}
                    onClick={() => setGrid(!grid)}
                >
                    {iconwrapper(GRID_ICON, { width: iconsize, height: iconsize })}
                </button>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'TEMPLATE' ? { color: 'var(--mainpink)', marginLeft: simulatordevice === 'p' ? 0 : 5 } : { color: 'var(--maindark)', marginLeft: simulatordevice === 'p' ? 0 : 5 }}
                    onClick={() => setRightcontentkey(rightcontentkey === 'TEMPLATE' ? '' : 'TEMPLATE')}
                >
                    {iconwrapper(ITINERARYTEMPLATE_ICON, { width: iconsize, height: iconsize })}
                </button>

            </div>

            {alldevicesbtns}

            <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end', width: 'calc((100% - 122px )/2)' }}>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'FRAME' ? { color: 'var(--mainpink)' } : { color: 'var(--maindark)' }}
                    onClick={() => setRightcontentkey(rightcontentkey === 'FRAME' ? '' : 'FRAME')}
                >
                    {iconwrapper(FRAME_ICON, { width: iconsize, height: iconsize })}
                </button>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'COLOR' ? { color: 'var(--mainpink)' } : { color: 'var(--maindark)' }}
                    onClick={() => setRightcontentkey(rightcontentkey === 'COLOR' ? '' : 'COLOR')}
                >
                    {iconwrapper(COLOR_ICON, { width: iconsize, height: iconsize })}
                </button>

                <button
                    className="itinerary_colorbtn"
                    style={rightcontentkey === 'CORNERIMG'
                        ? { color: 'var(--mainpink)', backgroundImage: `url(${cornerimg})`, border: '1px solid var(--maindark)', backgroundSize: 'contain' }
                        : { color: 'var(--maindark)', backgroundImage: `url(${cornerimg})`, border: '1px solid var(--maindark)', backgroundSize: 'contain' }
                    }
                    onClick={() => setRightcontentkey(rightcontentkey === 'CORNERIMG' ? '' : 'CORNERIMG')}
                >
                </button>

                {simulatordevice === 'P'  // allow RESIZE btn if is P - Printing Mode
                    ? <button
                        className="itinerary_colorbtn"
                        style={rightcontentkey === 'PRINTINGSIZE' ? { color: 'var(--mainpink)' } : { color: 'var(--maindark)' }}
                        onClick={() => setRightcontentkey(rightcontentkey === 'PRINTINGSIZE' ? '' : 'PRINTINGSIZE')}
                    >
                        {iconwrapper(RESIZE_ICON, { width: iconsize, height: iconsize })}
                    </button>
                    : null}

                {simulatordevice === 'P'
                    ? <button
                        className='scedit_qrbtn'
                        style={{ margin: ' 0px 0px 0px 5px', right: 0 }}
                        onClick={() => {
                            setAllowedit(false)
                            setSelectededitindex(-1)
                            setRightcontentkey('')
                            // download()
                            setDownloadmodal(true)
                        }}
                    >
                        {iconwrapper(DOWNLOAD_ICON, { width: iconsize, height: iconsize })}
                    </button>
                    : null}

            </div>

        </div>

        {(tlobjs && tlobjs.length === 0)
            ? left_template_or_add_dom
            : <Itinerarylookup
                from='EDIT'
                hover={hover}
                downloadmodal={downloadmodal}
                grid={grid}
                allowedit={allowedit}
                downloadtransparent={downloadtransparent}
                selectededitindex={selectededitindex}
                simulatordevice={simulatordevice}
                tlobjs={tlobjs}
                bgcolor={bgcolor}
                cornerimg={cornerimg}
                frame={frame}
                framecolor={framecolor}
                framecorner={framecorner}
                framestroke={framestroke}
                framethickness={framethickness}
                opencornerimg={() => {
                    setRightcontentkey(rightcontentkey === 'CORNERIMG' ? '' : 'CORNERIMG')
                }}
                onDragStart={() => {
                    setIsDragging(true);
                    document.body.style.cursor = "grabbing"; // Set cursor to grabbing during drag
                }}
                onDragEnd={(result) => {

                    setIsDragging(false);
                    document.body.style.cursor = "default"; // Reset cursor after drag

                    setRightcontentkey('NONE');
                    setSelectededitindex(-1);
                    setSelectedaddindex(-1)
                    setToporbtm('');

                    const { source, destination } = result
                    if (!destination) { return }

                    let curr_tlobjs = tlobjs.slice()
                    const [removed] = curr_tlobjs.splice(source.index, 1);
                    curr_tlobjs.splice(destination.index, 0, removed);

                    setTlobjs(curr_tlobjs)
                }}

                edit={(index, component) => {// pencil edit for each component
                    setSelectededitindex(index)
                    setRightcontentkey(component)
                }}
                addtop={(index) => {
                    setRightcontentkey('ADD')
                    setSelectedaddindex(index)
                    setToporbtm('TOP')
                }}
                addbtm={(index) => {
                    setRightcontentkey('ADD')
                    setSelectedaddindex(index)
                    setToporbtm('BTM')
                }}
            />}
    </div>

    const addrightcomp = (e) => {
        const { value } = e.target
        const curr_tlobjs = JSON.parse(JSON.stringify(tlobjs))
        let newitem
        if (value === 'TEXT') {
            newitem = {
                component: 'TEXT',
                content: 'Some text ',
                fontStyle: 'normal', // normal or italic
                fontWeight: 'normal', // normal or bold
                fontFamily: 'Lato',
                textAlign: 'center', // flex-start, center, flex-end
                url: '',// clickable link for redirect when content clicked.
                color: '#333333', // font color            
                device: {
                    'W': { // WEB 
                        fontSize: 18,
                        marginBottom: 0,
                        marginTop: 0
                    },

                    'T': { //  TABLET
                        fontSize: 18,
                        marginBottom: 0,
                        marginTop: 0
                    },

                    'M': { // MOBILE
                        fontSize: 16,
                        marginBottom: 0,
                        marginTop: 0
                    },
                    'P': {
                        fontSize: 18,
                        marginBottom: 0,
                        marginTop: 0
                    }
                }
            }
        }
        else if (value === 'BANNER') {
            newitem = {
                component: 'BANNER',
                url: '',
                device: {
                    'W': { // WEB 
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,

                    },
                    'T': { // TABLET
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,

                    },
                    'M': { // MOBILE
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                    },
                    'P': {
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,

                    },
                }
            }
        }
        else if (value === 'TIMELINE') {
            newitem = {
                component: 'TIMELINE',
                size: 1, // different sizing of the timeline component
                mode: 0, // 0 - with icon, 1 no icon
                title: {
                    value: 'Timeline Title', // 'Morning Preparation',
                    fontFamily: 'Marck Script',
                    color: '#333333',
                    justifyContent: 'center', // start, center, end
                    fontStyle: 'normal', // normal or italic
                    fontWeight: 'bold', // normal or bold
                    device: {
                        'W': { // WEB 
                            fontSize: 24,
                            marginTop: 5,
                            marginBottom: 0,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                        'T': { // TABLET
                            fontSize: 24,
                            marginTop: 5,
                            marginBottom: 0,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                        'M': { // MOBILE
                            fontSize: 25,
                            marginTop: 5,
                            marginBottom: 0,
                            marginLeft: 5,
                            marginRight: 0,
                        },
                        'P': {
                            fontSize: 24,
                            marginTop: 5,
                            marginBottom: 0,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                    }
                },
                content: {
                    value: `-`, // arrives at bride's home for makeup and hair styling. Bride and bridesmaids will be getting ready together.
                    fontFamily: 'Lato',
                    color: '#333333',
                    justifyContent: 'center', // start, center, end
                    fontStyle: 'normal', // normal or italic
                    fontWeight: 'normal', // normal or bold
                    device: {
                        'W': { // WEB
                            fontSize: 16,
                            marginTop: 10,
                            marginBottom: 50,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                        'T': { // TABLET
                            fontSize: 16,
                            marginTop: 10,
                            marginBottom: 50,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                        'M': { // MOBILE
                            fontSize: 14,
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                        'P': {
                            fontSize: 16,
                            marginTop: 10,
                            marginBottom: 50,
                            marginLeft: 5,
                            marginRight: 5,
                        },
                    }
                },
                time: {
                    value: '08:00 hr', // 16:00 hr
                    fontFamily: 'Lato',
                    color: '#333333',
                    justifyContent: 'end', // start, center, end
                    fontStyle: 'normal', // normal or italic
                    fontWeight: 'normal', // normal or bold
                    device: {
                        'W': { // TABLET
                            fontSize: 18,
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 0,
                            marginRight: 5,
                        },
                        'T': { // TABLET
                            fontSize: 18,
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 0,
                            marginRight: 5,
                        },
                        'M': { // MOBILE
                            fontSize: 16,
                            marginBottom: 10,
                            marginTop: 10,
                            marginLeft: 0,
                            marginRight: 5,
                        },
                        'P': {
                            fontSize: 18,
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 0,
                            marginRight: 5,
                        },
                    }
                },
                icon: {
                    state: true,// true or false of icon
                    value: ICONNAME_ICON_MAP[0], // ICONNAME_ICON_MAP[0]
                    color: '#333333',
                }

            }
        }
        else if (value === 'IMAGE') {
            newitem = {
                component: 'IMAGE',
                value: 'couple',// couple or image
                coupleimg1: '', // url to couple img 1
                coupleimg2: '',// url to couple img 2
                singleimg: '',// url to single img
                coupleheartstate: true, // true or false
                coupleheartcolor: '#eb5d7b'
            }
        }
        else if (value === 'EMPTYSPACE') {
            newitem = {
                component: 'EMPTYSPACE',
                value: 'Thin',
            }
        }

        if (toporbtm.length > 0) {
            let newindexing
            if (toporbtm === 'TOP') {
                curr_tlobjs.splice(selectedaddindex, 0, newitem)
                newindexing = selectedaddindex
            }
            else if (toporbtm === 'BTM') {
                curr_tlobjs.splice(selectedaddindex + 1, 0, newitem)
                newindexing = selectedaddindex + 1
            }
            setTlobjs(curr_tlobjs)
            setRightcontentkey(value)
            setSelectededitindex(newindexing)
            setSelectedaddindex(-1)
        }
        else {
            curr_tlobjs.push(newitem)
            setSelectededitindex(0)
            setSelectedaddindex(-1)
            setTlobjs(curr_tlobjs)
            setRightcontentkey(value)
        }

    }

    const closebtn = <button
        className="Itineraryedit_closebtn"
        onClick={() => {
            setRightcontentkey('NONE');
            setSelectededitindex(-1);
            setSelectedaddindex(-1)
            setToporbtm('');
        }}>
        <svg
            className="icon"
            style={{ ...s_, width: 32, height: 32, borderRadius: '100%', backgroundColor: 'white' }}
            viewBox={vb_}
            version={v_}
            xmlns={x_}
        >
            <path style={{ fill: '#333333', }} d="M442.24 517.504l-114.88 115.2a48 48 0 1 0 67.968 67.776l114.688-115.008L624.768 700.48a48 48 0 0 0 67.968-67.84l-114.88-115.136 114.88-115.072a48 48 0 1 0-67.968-67.84L510.016 449.6 395.328 334.592a48 48 0 0 0-67.968 67.84l114.88 115.072zM512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z" fill="#666666" p-id="10405"></path>
        </svg>
    </button>

    const delbtn = <div style={{ display: 'flex', left: 0, position: 'absolute' }}>
        <button className="itinerary_deletedbtn" onClick={deletefunc}>
            {iconwrapper(TRASH_ICON, { width: 23, height: 23 })}
            <div style={{ paddingLeft: 7 }}>Delete</div>
        </button>
    </div>

    const text_fontsize_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['fontSize'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const text_fontsize_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['fontSize'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const text_topspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['marginTop'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const text_topspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['marginTop'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const text_btmspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['marginBottom'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const text_btmspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['marginBottom'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const banner_size_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['paddingRight'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const banner_size_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['paddingRight'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const banner_topspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['paddingTop'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const banner_topspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['paddingTop'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const banner_btmspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['paddingBottom'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const banner_btmspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex]['device'][simulatordevice]['paddingBottom'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_fontsize_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['fontSize'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_fontsize_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['fontSize'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_topspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginTop'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_topspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginTop'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_btmspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginBottom'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_btmspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginBottom'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_leftspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginLeft'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_leftspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginLeft'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_rightspace_dec = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginRight'] -= 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }
    const timeline_rightspace_inc = () => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginRight'] += 1
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }

    const clickthickness = (e) => {
        let curr_tlobjs = tlobjs.slice()
        curr_tlobjs[selectededitindex].value = e.target.value
        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
    }

    const framecorner_inc = () => {
        setFramecorner((newval) => {
            return newval + 1
        })
    }

    const framecorner_dec = () => {
        setFramecorner((newval) => {
            return newval - 1
        })
    }

    const inputcoupleimg_onchange = (event, api, where) => {
        var reader = new FileReader()
        let file = event.target.files[0]
        reader.onload = (e) => {
            var imgelem = document.createElement("img");
            imgelem.onload = async () => {
                const [dataurl, downsizedBlob] = Imagedownsize(imgelem, 'logo', 80, 80)
                const { key, uploadURL } = await getPresignedUrlWithToken(token, GET_TLS3PRESIGNEDURL);
                await uploadToS3(downsizedBlob, uploadURL);
                const { message, loc } = await notifyBackendUpload(token, { key, objs: JSON.stringify(tlobjs.slice()), selectededitindex, _id: id, urlhandler }, api);
                if (message === 'SUCCESS') {
                    let curr_tlobjs = tlobjs.slice()
                    curr_tlobjs[selectededitindex][where] = loc;
                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                }




                // var newData = new FormData()
                // newData.append('file', downsizedBlob)
                // newData.append('objs', JSON.stringify(tlobjs.slice()))
                // newData.append('selectededitindex', selectededitindex)
                // newData.append('_id', id)
                // newData.append('urlhandler', urlhandler)
                // let options = {
                //     method: 'POST',
                //     url: api,
                //     headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }, // need token from the web
                //     data: newData
                // }
                // axios(options).then((result) => {
                //     const { data, status } = result
                //     const { message, loc } = data
                //     if (status === 200) {
                //         if (message === 'SUCCESS') {
                //             let curr_tlobjs = tlobjs.slice()
                //             curr_tlobjs[selectededitindex][where] = loc;
                //             setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                //         }
                //     }
                // }).catch(e => { })




            }
            imgelem.src = e.target.result;
        }
        reader.readAsDataURL(file);
    }

    const inputimg_onchange = (e) => {
        var reader = new FileReader()
        let file = event.target.files[0]
        reader.onload = (e) => {
            var imgelem = document.createElement("img");
            imgelem.onload = () => {
                const [dataurl, downsizedBlob] = Imagedownsize(img, "logo");
                var newData = new FormData()
                newData.append('file', downsizedBlob)
                newData.append('objs', JSON.stringify(tlobjs.slice()))
                newData.append('selectededitindex', selectededitindex)
                newData.append('_id', id)
                newData.append('urlhandler', urlhandler)
                let options = {
                    method: 'POST',
                    url: api,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }, // need token from the web
                    data: newData
                }
                axios(options).then((result) => {
                    const { data, status } = result
                    const { message, loc } = data
                    if (status === 200) {
                        if (message === 'SUCCESS') {
                            let curr_tlobjs = tlobjs.slice()
                            curr_tlobjs[selectededitindex][where] = loc;
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        }
                    }
                }).catch(e => { })
            }
            imgelem.src = e.target.result;
        }
        reader.readAsDataURL(file);
    }

    const closebtn_local = <button
        className="Itineraryedit_closebtn"
        onClick={() => {

        }}>
        <svg
            className="icon"
            style={{ ...s_, width: 32, height: 32, borderRadius: '100%', backgroundColor: 'white', top: 0, position: 'absolute' }}
            viewBox={vb_}
            version={v_}
            xmlns={x_}
        >
            <path style={{ fill: '#333333', }} d="M442.24 517.504l-114.88 115.2a48 48 0 1 0 67.968 67.776l114.688-115.008L624.768 700.48a48 48 0 0 0 67.968-67.84l-114.88-115.136 114.88-115.072a48 48 0 1 0-67.968-67.84L510.016 449.6 395.328 334.592a48 48 0 0 0-67.968 67.84l114.88 115.072zM512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z" fill="#666666" p-id="10405"></path>
        </svg>
    </button>


    const right_dom = <div className={`itineraryedit_right itineraryedit_right${device}`}>
        {{
            // will appear if user is first time using
            NONE: <></>,

            // will appear if user is first time using
            TEMPLATE: <div className="itinerary_rightcontentroot">
                <div className="Rsvpexplorer_portaltitle" style={{ top: 0, position: 'absolute', width: '100%' }}>Template</div>
                {closebtn}
                {Object.keys(TEMPLATE_CONTENT).map((maintitle, i) => {
                    return <div key={maintitle + i} className="itineraryedit_templateroot">
                        <div className="itinerary_templatecontent">
                            {TEMPLATE_CONTENT[maintitle]
                                .map((item, index) => {
                                    const { title, data, bgcolor } = item // description,
                                    const newdata = JSON.stringify(data)
                                    return <button
                                        onClick={() => {
                                            setCfaddnewtemplate(true)
                                            setNewtemplatedata(JSON.parse(newdata))
                                            setBgcolor(bgcolor)
                                        }}
                                        className="Itineraryedit_rightcontentrootbtn"
                                        key={index + 'template'}
                                        style={{ placeContent: 'center', display: 'flex', textAlign: 'center', alignItems: 'start' }}
                                    >
                                        <div>{title}</div>
                                        {/* <div>{description}</div> */}
                                    </button>
                                })}
                        </div>
                    </div>
                })}
            </div>,

            // will appear if user is first time using
            ADD: <div className="itinerary_rightcontentroot">
                {closebtn}
                <button className="Itineraryedit_rightcontentrootbtn" onClick={addrightcomp} value={'TEXT'}>Text</button>

                <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'TIMELINE'}>Timeline</button>
                {numimgobjs < maximgobj ? <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'IMAGE'}>Image</button> : null}
                <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'EMPTYSPACE'}>Empty Space</button>

                <button className="Itineraryedit_rightcontentrootbtn" style={{ marginTop: 5 }} onClick={addrightcomp} value={'BANNER'}>Banner</button>
            </div>,

            TEXT: selectededitindex > -1 && rightcontentkey === 'TEXT'
                ? <div className="itinerary_rightcontentroot" >
                    {delbtn}
                    {closebtn}

                    {/* content */}
                    {textarea_dom(
                        'Content',
                        'Some Content',
                        tlobjs[selectededitindex].content,
                        (e) => {
                            const { value } = e.target
                            let curr_tlobjs = JSON.parse(JSON.stringify(tlobjs))
                            curr_tlobjs[selectededitindex].content = value
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        },
                        'tlobj' + selectededitindex,
                        {},
                        false,
                        null,
                        {},
                        txtarea_css,
                        3,
                        null
                    )}
                    <div style={{ height: 10 }} />

                    {/* font-family */}
                    {multiplechoice_dom(
                        'Font Family',
                        ENGLISH_FF,
                        (e) => {
                            const { value } = e.target
                            let curr_tlobjs = JSON.parse(JSON.stringify(tlobjs))
                            curr_tlobjs[selectededitindex].fontFamily = value
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        },
                        'FF_ID',
                        [],
                        tlobjs[selectededitindex].fontFamily
                    )}

                    {/* font-style & font-weight */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Font Settings', {})}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 5px',
                                    backgroundColor: tlobjs[selectededitindex]['fontStyle'] === 'italic' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex]['fontStyle'] === 'italic' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex]['fontStyle'] = tlobjs[selectededitindex]['fontStyle'] === 'italic' ? 'normal' : 'italic'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                Italic
                            </button>
                            <div style={{ height: 40, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 5px 0px',
                                    backgroundColor: tlobjs[selectededitindex]['fontWeight'] === 'bold' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex]['fontWeight'] === 'bold' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex]['fontWeight'] = tlobjs[selectededitindex]['fontWeight'] === 'bold' ? 'normal' : 'bold'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                Bold
                            </button>
                        </div>
                    </div>

                    <div style={{ height: 10 }} />

                    {/* text-align */}
                    {/* <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Text-align', {})}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRadius: '5px 0px 0px 5px',
                                    borderRight: 'none',
                                    backgroundColor: tlobjs[selectededitindex]['textAlign'] === 'start' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex]['textAlign'] === 'start' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex]['textAlign'] = 'start'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                Start
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none', borderLeft: 'none',
                                    backgroundColor: tlobjs[selectededitindex]['textAlign'] === 'center' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex]['textAlign'] === 'center' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex]['textAlign'] = 'center'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                Center
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRadius: '0px 5px 5px 0px',
                                    borderLeft: 'none',
                                    backgroundColor: tlobjs[selectededitindex]['textAlign'] === 'end' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex]['textAlign'] === 'end' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex]['textAlign'] = 'end'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                End
                            </button>
                        </div>
                    </div> */}

                    <div style={{ height: 10 }} />

                    {/* device specific */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Device Specific Settings', {})}
                        {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'W' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'W' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='W'
                            >
                                Web
                            </button>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'T' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'T' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='T'
                            >
                                Tablet
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'M' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'M' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='M'
                            >
                                Mobile
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: simulatordevice === 'P' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'P' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='P'
                            >
                                Print
                            </button>
                        </div>
                    </div>

                    <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>
                        {/* device specific - fontsize */}
                        {partialtitle_dom('Font-size', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_fontsize_dec}
                                {...onLongPress(text_fontsize_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex]['device'][simulatordevice]['fontSize']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_fontsize_inc}
                                {...onLongPress(text_fontsize_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />

                        {/* device specific - marginTop & marginBottom */}
                        {partialtitle_dom('Space-Top', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_topspace_dec}
                                {...onLongPress(text_topspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex]['device'][simulatordevice]['marginTop']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_topspace_inc}
                                {...onLongPress(text_topspace_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Bottom', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_btmspace_inc}
                                {...onLongPress(text_btmspace_inc)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex]['device'][simulatordevice]['marginBottom']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={text_btmspace_dec}
                                {...onLongPress(text_btmspace_dec)}
                            >
                                +
                            </button>
                        </div>

                    </div>
                    <div style={{ height: 10 }} />

                    {/* url input */}

                    <div style={{ height: 10 }} />
                    {/* color */}
                    {partialtitle_dom('Font Color', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <HexColorPicker
                        style={{ height: 200, width: 'calc( 100% - 20px )' }}
                        color={tlobjs[selectededitindex]['color']}
                        onChange={(e) => {
                            let curr_tlobjs = tlobjs.slice()
                            tlobjs[selectededitindex]['color'] = e
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        }} />
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                        <HexColorInput
                            color={tlobjs[selectededitindex]['color']}
                            onChange={(e) => {
                                let curr_tlobjs = tlobjs.slice()
                                tlobjs[selectededitindex]['color'] = e
                                setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                            }}
                            style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                        />
                    </div>
                    {/* {JSON.stringify(tlobjs[selectededitindex])} */}
                    <div style={{ height: 100 }} />
                </div>
                : null,

            BANNER: selectededitindex > -1 && rightcontentkey === 'BANNER'
                ? <div className="itinerary_rightcontentroot">
                    {delbtn}
                    {closebtn}

                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column', placeContent: 'center', margin: '0px 10px' }}>
                        {partialtitle_dom('Device Specific Settings', {})}
                        {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'W' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'W' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='W'
                            >
                                Web
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'T' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'T' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='T'
                            >
                                Tablet
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'M' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'M' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='M'
                            >
                                Mobile
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: simulatordevice === 'P' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'P' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='P'
                            >
                                Print
                            </button>
                        </div>
                    </div>

                    <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>

                        {/* device specific - paddingleft and paddingRight, control the size of banner*/}
                        {partialtitle_dom('Size of banner', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_size_dec}
                                {...onLongPress(banner_size_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex]['device'][simulatordevice]['paddingRight'] * -1}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_size_inc}
                                {...onLongPress(banner_size_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Top', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_topspace_dec}
                                {...onLongPress(banner_topspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex]['device'][simulatordevice]['paddingTop']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_topspace_inc}
                                {...onLongPress(banner_topspace_inc)}
                            >
                                +
                            </button>
                        </div>

                        <div style={{ height: 10 }} />

                        {partialtitle_dom('Space-Bottom', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_btmspace_dec}
                                {...onLongPress(banner_btmspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex]['device'][simulatordevice]['paddingBottom']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={banner_btmspace_inc}
                                {...onLongPress(banner_btmspace_inc)}
                            >
                                +
                            </button>
                        </div>

                    </div>

                    <div style={{ height: 10 }} />
                    <div style={{ width: 'calc( 100% - 20px )' }}>
                        {partialtitle_dom('Banners', {})}
                        <Banners
                            select={({ index }) => {
                                let url
                                if (index > 0) {
                                    url = banners[index]
                                }
                                else {
                                    url = ''
                                }
                                let curr_tlobjs = tlobjs.slice()
                                tlobjs[selectededitindex]['url'] = url
                                setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                            }}
                            selected={tlobjs[selectededitindex]['url']}
                            banners={banners}
                            names={bannernames}
                        />
                    </div>

                    <div style={{ height: 100 }} />
                </div>
                : null,

            TIMELINE: selectededitindex > -1 && rightcontentkey === 'TIMELINE'
                ? <div className="itinerary_rightcontentroot">
                    {delbtn}
                    {closebtn}

                    {/* menu */}
                    <div className='itinerary_timelinemenu'>
                        <button className={`itinerary_timelinemenubtn ${selectedtlmenubtn === 'Title' ? 'itinerary_timelinemenubtnselected' : ''}`} onClick={() => setSelectedtlmenubtn('Title')} >Title</button>
                        <button className={`itinerary_timelinemenubtn ${selectedtlmenubtn === 'Content' ? 'itinerary_timelinemenubtnselected' : ''}`} onClick={() => setSelectedtlmenubtn('Content')} >Content</button>
                        <button className={`itinerary_timelinemenubtn ${selectedtlmenubtn === 'Time' ? 'itinerary_timelinemenubtnselected' : ''}`} onClick={() => setSelectedtlmenubtn('Time')} >Time</button>
                    </div>

                    {/* content */}
                    {textarea_dom(
                        selectedtlmenubtn,
                        'Some Title',
                        tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].value,
                        (e) => {
                            const { value } = e.target
                            let curr_tlobjs = JSON.parse(JSON.stringify(tlobjs))
                            curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].value = value
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        },
                        'tlobj' + selectededitindex,
                        {},
                        false,
                        null,
                        {},
                        txtarea_css,
                        3,
                        null
                    )}

                    <div style={{ height: 10 }} />

                    {/* font-family */}
                    {multiplechoice_dom(
                        'Font Family',
                        ENGLISH_FF,
                        (e) => {
                            const { value } = e.target
                            let curr_tlobjs = JSON.parse(JSON.stringify(tlobjs))
                            curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].fontFamily = value
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        },
                        'FF_ID',
                        [],
                        tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].fontFamily
                    )}

                    <div style={{ height: 10 }} />

                    {/* color */}
                    {partialtitle_dom('Font Color', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <HexColorPicker
                        style={{ height: 200, width: 'calc( 100% - 20px )' }}
                        color={tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].color}
                        onChange={(e) => {
                            let curr_tlobjs = tlobjs.slice()
                            curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].color = e
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        }} />
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                        <HexColorInput
                            color={tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].color}
                            onChange={(e) => {
                                let curr_tlobjs = tlobjs.slice()
                                curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].color = e
                                setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                            }}
                            style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                        />
                    </div>

                    <div style={{ height: 10 }} />

                    {/* font setting, font-style & font-weight */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Font Settings', {})}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 5px',
                                    backgroundColor: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontStyle'] === 'italic' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontStyle'] === 'italic' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontStyle'] = tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontStyle'] === 'italic' ? 'normal' : 'italic'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                Italic
                            </button>
                            <div style={{ height: 40, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 5px 0px',
                                    backgroundColor: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontWeight'] === 'bold' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontWeight'] === 'bold' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    curr_tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontWeight'] = tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['fontWeight'] === 'bold' ? 'normal' : 'bold'
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                            >
                                Bold
                            </button>
                        </div>
                    </div>

                    <div style={{ height: 10 }} />

                    {/* Alignment, time only */}
                    {selectedtlmenubtn.toLocaleLowerCase() === 'time'
                        ? <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                            {partialtitle_dom('Alignment', {})}
                            <div className="itinerary_rightcontentbtngrp">
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{
                                        borderRadius: '5px 0px 0px 5px',
                                        borderRight: 'none',
                                        backgroundColor: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] === 'start' ? 'var(--mainpink)' : '#ffffff',
                                        color: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] === 'start' ? '#ffffff' : 'var(--maindark)',
                                    }}
                                    onClick={() => {
                                        let curr_tlobjs = tlobjs.slice()
                                        tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] = 'start'
                                        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                    }}
                                >
                                    Start
                                </button>
                                <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{
                                        borderRight: 'none', borderLeft: 'none',
                                        backgroundColor: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] === 'center' ? 'var(--mainpink)' : '#ffffff',
                                        color: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] === 'center' ? '#ffffff' : 'var(--maindark)',
                                    }}
                                    onClick={() => {
                                        let curr_tlobjs = tlobjs.slice()
                                        tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] = 'center'
                                        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                    }}
                                >
                                    Center
                                </button>
                                <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{
                                        borderRadius: '0px 5px 5px 0px',
                                        borderLeft: 'none',
                                        backgroundColor: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] === 'end' ? 'var(--mainpink)' : '#ffffff',
                                        color: tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] === 'end' ? '#ffffff' : 'var(--maindark)',
                                    }}
                                    onClick={() => {
                                        let curr_tlobjs = tlobjs.slice()
                                        tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['justifyContent'] = 'end'
                                        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                    }}
                                >
                                    End
                                </button>
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />

                    {/* device specific */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Device Specific Settings', {})}
                        {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'W' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'W' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='W'
                            >
                                Web
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'T' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'T' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='T'
                            >
                                Tablet
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderRadius: '0px 0px 0px 0px',
                                    backgroundColor: simulatordevice === 'M' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'M' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='M'
                            >
                                Mobile
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: simulatordevice === 'P' ? 'var(--mainpink)' : '#ffffff',
                                    color: simulatordevice === 'P' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => setSimulatordevice(e.target.value)}
                                value='P'
                            >
                                Print
                            </button>
                        </div>
                    </div>
                    <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>
                        {/* device specific - fontsize */}
                        {partialtitle_dom('Font-size', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_fontsize_dec}
                                {...onLongPress(timeline_fontsize_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['fontSize']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_fontsize_inc}
                                {...onLongPress(timeline_fontsize_inc)}
                            >
                                +
                            </button>
                        </div>

                        <div style={{ height: 10 }} />

                        {/* device specific - marginTop & marginBottom */}
                        {partialtitle_dom('Space-Top', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_topspace_dec}
                                {...onLongPress(timeline_topspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginTop']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_topspace_inc}
                                {...onLongPress(timeline_topspace_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />
                        {partialtitle_dom('Space-Bottom', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_btmspace_dec}
                                {...onLongPress(timeline_btmspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginBottom']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_btmspace_inc}
                                {...onLongPress(timeline_btmspace_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />
                        {partialtitle_dom('Space-Left', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_leftspace_dec}
                                {...onLongPress(timeline_leftspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginLeft']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_leftspace_inc}
                                {...onLongPress(timeline_leftspace_inc)}
                            >
                                +
                            </button>
                        </div>
                        <div style={{ height: 10 }} />
                        {partialtitle_dom('Space-Right', {})}
                        <div className="Itinerary_rightcontentsubcompfsroot">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_rightspace_dec}
                                {...onLongPress(timeline_rightspace_dec)}
                            >
                                -
                            </button>
                            <div className="itinerary_rightcontentnum">{tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()]['device'][simulatordevice]['marginRight']}</div>
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{ borderRadius: 20, fontSize: 18 }}
                                onClick={timeline_rightspace_inc}
                                {...onLongPress(timeline_rightspace_inc)}
                            >
                                +
                            </button>
                        </div>

                    </div>

                    <div style={{ height: 20 }} />

                    {/* ---------------------------------------------------------------------- */}
                    {/* icon */}
                    <div className="itinerary_rightcontentsubcomp" >
                        {radiobtn_dom(
                            tlobjs[selectededitindex]['icon']['state'],
                            () => {
                                let curr_tlobjs = tlobjs.slice()
                                curr_tlobjs[selectededitindex]['icon']['state'] = !curr_tlobjs[selectededitindex]['icon']['state']
                                setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                            },
                            tlobjs[selectededitindex]['icon']['state'] ? `Icon Enabled` : `Icon Disabled`,
                            { borderTop: '1px solid var(--subgrey)', paddingTop: 20, width: '100%' }
                        )}
                    </div>

                    {tlobjs[selectededitindex]['icon']['state']
                        ? <>
                            <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column', paddingTop: 20 }}>
                                {partialtitle_dom('Icon', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                                {inputdescribe_dom('Add an icon to help convey information and add visual interest to your timeline.')}
                                <button className="itinerary_timelinemenuicon" style={{ fill: tlobjs[selectededitindex]['icon'].color }} onClick={() => setIconportal(true)} >
                                    <svg className="icon" style={{ ...s_, fill: tlobjs[selectededitindex]['icon'].color }} viewBox={vb_} version={v_} xmlns={x_} >
                                        <path d={tlobjs[selectededitindex]['icon'].value} />
                                    </svg>
                                </button>
                            </div>
                            <div style={{ height: 10 }} />

                            {partialtitle_dom('Icon Color ', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                            <HexColorPicker
                                style={{ height: 200, width: 'calc( 100% - 20px )' }}
                                color={tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].color}
                                onChange={(e) => {
                                    let curr_tlobjs = tlobjs.slice()
                                    curr_tlobjs[selectededitindex]['icon'].color = e
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }} />
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                                <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                <HexColorInput
                                    color={tlobjs[selectededitindex][selectedtlmenubtn.toLowerCase()].color}
                                    onChange={(e) => {
                                        let curr_tlobjs = tlobjs.slice()
                                        curr_tlobjs[selectededitindex]['icon'].color = e
                                        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                    }}
                                    style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                />
                            </div>
                        </>
                        : null}

                    {/* color */}


                    <div style={{ height: 20 }} />

                    {/* ---------------------------------------------------------------------- */}
                    {/* Mode */}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column', borderTop: '1px solid var(--subgrey)', paddingTop: 20 }}>
                        {partialtitle_dom('Size', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                        {inputdescribe_dom('Click to select different size of each timeline component.')}
                        {{
                            0: <button
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    if (curr_tlobjs[selectededitindex]['size'] === 1) {
                                        curr_tlobjs[selectededitindex]['size'] = 0
                                    }
                                    else {
                                        curr_tlobjs[selectededitindex]['size'] = 1
                                    }
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                                style={{ width: '100%', height: 50, border: '1px solid var(--maindark)', backgroundColor: '#ffffff', borderRadius: 5, position: 'relative', padding: 0, display: 'flex', flexDirection: 'row' }}
                            >
                                <div style={{ width: '40%', height: '100%', alignItems: 'center', placeContent: 'center', display: 'flex', }} >Time</div>
                                <div style={{ width: '20%', height: '100%', alignItems: 'center', placeContent: 'center', display: 'flex', border: '1px solid var(--maindark)', borderTop: 'none', borderBottom: 'none', }}>Icon</div>
                                <div style={{ width: '40%', height: '100%', alignItems: 'center', placeContent: 'center', display: 'flex', }} >Content</div>
                            </button>,
                            1: <button
                                onClick={() => {
                                    let curr_tlobjs = tlobjs.slice()
                                    if (curr_tlobjs[selectededitindex]['size'] === 1) {
                                        curr_tlobjs[selectededitindex]['size'] = 0
                                    }
                                    else {
                                        curr_tlobjs[selectededitindex]['size'] = 1
                                    }
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                                style={{ width: '100%', height: 50, border: '1px solid var(--maindark)', backgroundColor: '#ffffff', borderRadius: 5, position: 'relative', padding: 0, display: 'flex', flexDirection: 'row' }}
                            >
                                <div style={{ width: '30%', height: '100%', alignItems: 'center', placeContent: 'center', display: 'flex', }} >Time</div>
                                <div style={{ width: '20%', height: '100%', alignItems: 'center', placeContent: 'center', display: 'flex', border: '1px solid var(--maindark)', borderTop: 'none', borderBottom: 'none', }}>Icon</div>
                                <div style={{ width: '50%', height: '100%', alignItems: 'center', placeContent: 'center', display: 'flex', }} >Content</div>
                            </button>
                        }[tlobjs[selectededitindex]['size']]}

                    </div>

                    <div style={{ height: 100 }} />

                </div>
                : null,

            EMPTYSPACE: selectededitindex > -1 && rightcontentkey === 'EMPTYSPACE'
                ? <div className="itinerary_rightcontentroot">
                    {delbtn}
                    {closebtn}
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <button
                            className='Itineraryedit_rightcontentrootbtn'
                            onClick={clickthickness}
                            style={tlobjs[selectededitindex].value === 'Thin'
                                ? { border: '1px solid var(--mainpink)', color: 'var(--mainpink)' }
                                : { border: '1px solid var(--maindark)', color: 'var(--maindark)' }
                            }
                            value='Thin'
                        >
                            Thin
                        </button>
                        <button
                            className='Itineraryedit_rightcontentrootbtn'
                            onClick={clickthickness}
                            style={tlobjs[selectededitindex].value === 'Medium'
                                ? { border: '1px solid var(--mainpink)', color: 'var(--mainpink)' }
                                : { border: '1px solid var(--maindark)', color: 'var(--maindark)' }
                            }
                            value='Medium'
                        >
                            Medium
                        </button>
                        <button
                            className='Itineraryedit_rightcontentrootbtn'
                            onClick={clickthickness}
                            style={tlobjs[selectededitindex].value === 'Large'
                                ? { border: '1px solid var(--mainpink)', color: 'var(--mainpink)' }
                                : { border: '1px solid var(--maindark)', color: 'var(--maindark)' }
                            }
                            value='Large'
                        >
                            Large
                        </button>
                    </div>
                </div>
                : null,

            IMAGE: selectededitindex > -1 && rightcontentkey === 'IMAGE'
                ? <div className="itinerary_rightcontentroot">
                    {/* <div className="Rsvpexplorer_portaltitle" style={{ top: 0, position: 'absolute', width: '100%' }}>Image</div> */}
                    {delbtn}
                    {closebtn}
                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>
                        {partialtitle_dom('Image Type', {})}
                        {/* {inputdescribe_dom('Settings are tailored to specific devices, please adjust them according to your preferences.')} */}
                        <div className="itinerary_rightcontentbtngrp">
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderRight: 'none',
                                    borderRadius: '5px 0px 0px 0px',
                                    backgroundColor: tlobjs[selectededitindex].value === 'couple' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex].value === 'couple' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex].value = e.target.value
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                                value='couple'
                            >
                                Couple Images
                            </button>
                            <div style={{ height: 40, width: 1, borderLeft: '1px solid var(--maindark)' }} />
                            <button
                                className='itinerary_rightcontentbtn'
                                style={{
                                    borderLeft: 'none',
                                    borderRadius: '0px 5px 0px 0px',
                                    backgroundColor: tlobjs[selectededitindex].value === 'image' ? 'var(--mainpink)' : '#ffffff',
                                    color: tlobjs[selectededitindex].value === 'image' ? '#ffffff' : 'var(--maindark)',
                                }}
                                onClick={(e) => {
                                    let curr_tlobjs = tlobjs.slice()
                                    tlobjs[selectededitindex].value = e.target.value
                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                }}
                                value='image'
                            >
                                Image
                            </button>
                        </div>
                        {{
                            'couple': <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, width: '100%', borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>

                                <div className="Itinerary_rightcontentsubcompfsroot" style={{ flexDirection: 'column' }} >

                                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>

                                        {partialtitle_dom('Images Upload', {})}

                                        <div className="itinerary_rightcontentbtngrp">
                                            <div style={{ display: 'flex', flexDirection: 'row', }}>
                                                <img
                                                    // getS3fullpath_withbucketname('USER_PROFILE_IMG', profileimg)
                                                    key={tlobjs[selectededitindex]['coupleimg1'] + '_coupleimg1'}
                                                    src={tlobjs[selectededitindex]['coupleimg1'].length === 0
                                                        ? couple1
                                                        : S3CLOUD_CLOUDFRONT + tlobjs[selectededitindex]['coupleimg1']}
                                                    // : getS3fullpath_withbucketname('USER_ITINERARY_IMG', tlobjs[selectededitindex]['coupleimg1'])}

                                                    width={75}
                                                    height={75}
                                                    onClick={() => couple1ref.current.click()}
                                                    crossOrigin="anonymous"
                                                />
                                                <input
                                                    ref={couple1ref}
                                                    style={{ position: 'absolute', visibility: 'hidden' }}
                                                    accept="image/*"
                                                    type='file'
                                                    onChange={(e) => inputcoupleimg_onchange(e, UPDATE_TLCOUPLEIMG1, 'coupleimg1')}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'row', }}>
                                                <img
                                                    key={tlobjs[selectededitindex]['coupleimg2'] + '_coupleimg2'}
                                                    src={tlobjs[selectededitindex]['coupleimg2'].length === 0
                                                        ? couple2
                                                        : S3CLOUD_CLOUDFRONT + tlobjs[selectededitindex]['coupleimg2']}
                                                    // : getS3fullpath_withbucketname('USER_ITINERARY_IMG', tlobjs[selectededitindex]['coupleimg2'])}
                                                    // : tlobjs[selectededitindex]['coupleimg2']}
                                                    width={75}
                                                    height={75}
                                                    onClick={() => couple2ref.current.click()}
                                                    crossOrigin="anonymous"
                                                />
                                                <input
                                                    ref={couple2ref}
                                                    style={{ position: 'absolute', visibility: 'hidden' }}
                                                    accept="image/*"
                                                    type='file'
                                                    onChange={(e) => inputcoupleimg_onchange(e, UPDATE_TLCOUPLEIMG2, 'coupleimg2')}
                                                />
                                            </div>
                                        </div>

                                    </div>

                                    <div style={{ height: 10 }} />

                                    <div className="itinerary_rightcontentsubcomp" style={{ flexDirection: 'column' }}>

                                        {partialtitle_dom('Heart Icon', {})}

                                        <div className="itinerary_rightcontentbtngrp">
                                            {radiobtn_dom(
                                                tlobjs[selectededitindex]['coupleheartstate'],
                                                () => {
                                                    let curr_tlobjs = tlobjs.slice()
                                                    curr_tlobjs[selectededitindex]['coupleheartstate'] = !curr_tlobjs[selectededitindex]['coupleheartstate']
                                                    setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                                },
                                                tlobjs[selectededitindex]['coupleheartstate'] ? `Icon Enabled` : `Icon Disabled`,
                                                {}
                                                // { borderTop: '1px solid var(--subgrey)', paddingTop: 20, width: '100%' }
                                            )}
                                        </div>
                                    </div>

                                    <div style={{ height: 10 }} />
                                    {/* color */}
                                    {partialtitle_dom('Font Color', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                                    <HexColorPicker
                                        style={{ height: 200, width: 'calc( 100% - 20px )' }}
                                        color={tlobjs[selectededitindex]['coupleheartcolor']}
                                        onChange={(e) => {
                                            let curr_tlobjs = tlobjs.slice()
                                            tlobjs[selectededitindex]['coupleheartcolor'] = e
                                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                        }} />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                        <HexColorInput
                                            color={tlobjs[selectededitindex]['coupleheartcolor']}
                                            onChange={(e) => {
                                                let curr_tlobjs = tlobjs.slice()
                                                tlobjs[selectededitindex]['coupleheartcolor'] = e
                                                setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                            }}
                                            style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                        />
                                    </div>

                                </div>

                            </div>,
                            'image': <div className="itinerary_rightcontentsubcomp" style={{ border: '1px solid var(--maindark)', borderTop: 'none', flexDirection: 'column', padding: 10, width: '100%', borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>

                                {/* <div className="Itinerary_rightcontentsubcompfsroot" >
                                    <div style={{ display: 'flex', flexDirection: 'row', }}>
                                        <img
                                            key={tlobjs[selectededitindex]['singleimg'] + '_coupleimg1'}
                                            src={tlobjs[selectededitindex]['singleimg']}
                                            alt=""
                                            width={75}
                                            height={75}
                                            crossorigin="anonymous"
                                        />
                                    </div>
                                    <input
                                        ref={imgref}
                                        style={{ position: 'absolute', visibility: 'hidden' }}
                                        accept="image/*"
                                        type='file'
                                        onChange={inputimg_onchange}
                                    />
                                </div> */}
                                Coming Soon....
                            </div>
                        }[tlobjs[selectededitindex].value]}


                    </div>
                </div>
                : null,

            COLOR: rightcontentkey === 'COLOR'
                ? <div className="itinerary_rightcontentroot">
                    <div className="Rsvpexplorer_portaltitle" style={{ top: 0, position: 'absolute', width: '100%' }}>Color</div>
                    {closebtn}
                    {partialtitle_dom('Background Color ', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <HexColorPicker
                        style={{ height: 200, width: 'calc( 100% - 20px )' }}
                        color={bgcolor}
                        onChange={(e) => {
                            // let curr_tlobjs = tlobjs.slice()
                            // tlobjs[selectededitindex]['color'] = e
                            // setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                            setBgcolor(e)
                        }} />
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                        <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                        <HexColorInput
                            color={bgcolor}
                            onChange={(e) => {
                                // let curr_tlobjs = tlobjs.slice()
                                // tlobjs[selectededitindex]['color'] = e
                                // setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                                setBgcolor(e)

                            }}
                            style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                        />
                    </div>
                </div>
                : null,

            CORNERIMG: rightcontentkey === 'CORNERIMG'
                ? <div className="itinerary_rightcontentroot">
                    <div className="Rsvpexplorer_portaltitle" style={{ top: 0, position: 'absolute', width: '100%' }}>Corner Image</div>
                    {closebtn}
                    {/* {partialtitle_dom('Corner Image', { width: 'calc( 100% - 20px)', placeContent: 'start' })} */}
                    <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: '100%', paddingBottom: 60 }}>
                        <div className="itinerary_row">
                            <button
                                className="itinerary_applytoall"
                                onClick={() => {
                                    let new_tlobjs = JSON.parse(JSON.stringify(tlobjs))
                                    for (let i = 0; i < new_tlobjs.length; i++) {
                                        const { component } = new_tlobjs[i]
                                        if (component === 'BANNER') {

                                            new_tlobjs[i]['url'] = corners_banners_corners[cornerimgindex]['banner']
                                        }
                                    }
                                    setTlobjs(JSON.parse(JSON.stringify(new_tlobjs)))
                                }}
                            >
                                <div style={{ userSelect: 'none' }}>Apply</div>
                                <div style={{ userSelect: 'none' }}>To All Banners</div>
                            </button>
                            <Leftrightbtn
                                onLeft={() => {
                                    let index = -1
                                    for (let i = 0; i < corners_banners_corners.length; i++) {
                                        const { corner } = corners_banners_corners[i]
                                        if (cornerimg === corner) {
                                            index = i
                                            break
                                        }
                                    }
                                    if (index === 0) {
                                        setCornerimg(corners_banners_corners[corners_banners_corners.length - 1].corner)
                                        setCornerimgindex(corners_banners_corners.length - 1)
                                    }
                                    else {
                                        setCornerimg(corners_banners_corners[index - 1].corner)
                                        setCornerimgindex(index - 1)
                                    }
                                }}
                                onRight={() => {
                                    let index = -1
                                    for (let i = 0; i < corners_banners_corners.length; i++) {
                                        const { corner } = corners_banners_corners[i]
                                        if (cornerimg === corner) {
                                            index = i
                                            if (index === (corners_banners_corners.length - 1)) { index = -1 }
                                            break
                                        }
                                    }
                                    setCornerimg(corners_banners_corners[index + 1].corner)
                                    setCornerimgindex(index + 1)

                                }}
                            />
                        </div>

                        {corners_banners_corners.map(({ corner, banner, name }, index) => {
                            return <span key={corner + index} className="itinerary_corner_banner_root">

                                <div
                                    className={`${corner === cornerimg ? 'itinerary_bannernameselected' : 'itinerary_bannername'}`}
                                    onClick={() => {
                                        setCornerimg(corner)
                                        setCornerimgindex(index)
                                    }}
                                >
                                    {name}
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {index === 0
                                        ? <>
                                            <div
                                                className={`${corner === cornerimg ? 'itinerary_cornerselected' : 'itinerary_cornerselect'}`}
                                                style={{ borderRight: 'none' }}
                                                onClick={() => {
                                                    setCornerimg(corner)
                                                    setCornerimgindex(index)
                                                }}
                                                key={banner + '_' + corner + '_' + index + '_right'}
                                                src={corner}
                                                alt=""
                                            />
                                            <div
                                                className={`${corner === cornerimg ? 'itinerary_bannerselected' : 'itinerary_bannerselect'}`}
                                                onClick={() => {
                                                    setCornerimg(corner)
                                                    setCornerimgindex(index)
                                                }}
                                                key={banner + '_' + corner + '_' + index + '_left'}
                                                src={banner}
                                                alt=""
                                            />
                                        </>
                                        : <>
                                            <img
                                                className={`${corner === cornerimg ? 'itinerary_cornerselected' : 'itinerary_cornerselect'}`}
                                                onClick={() => {
                                                    setCornerimg(corner)
                                                    setCornerimgindex(index)
                                                }}
                                                key={banner + '_' + corner + '_' + index + '_right'}
                                                src={corner}
                                                alt=""
                                                crossOrigin="anonymous"
                                            />
                                            <img
                                                className={`${corner === cornerimg ? 'itinerary_bannerselected' : 'itinerary_bannerselect'}`}
                                                onClick={() => {
                                                    setCornerimg(corner)
                                                    setCornerimgindex(index)
                                                }}
                                                key={banner + '_' + corner + '_' + index + '_left'}
                                                src={banner}
                                                alt=""
                                                crossOrigin="anonymous"
                                            />
                                        </>}

                                </div>

                                {corner === cornerimg
                                    ? <div className="itinerary_bannercornerselected">
                                        Selected
                                    </div>
                                    : null}
                            </span>
                        })}

                    </div>

                </div>
                : null,

            FRAME: rightcontentkey === 'FRAME'
                ? <div className="itinerary_rightcontentroot">
                    <div className="Rsvpexplorer_portaltitle" style={{ top: 0, position: 'absolute', width: '100%' }}>Frame</div>
                    {closebtn}
                    {/* {partialtitle_dom('Frame', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <div style={{ padding: '0px 10px 10px 10px', width: 'calc( 100% - 20px)', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', border: '1px solid var(--subgrey)', borderRadius: 5 }}>
                        {['', '', '', ''].map((frameobj, index) => {
                            return <button
                                key={index + 'frame'}
                                value={index}
                                style={{ 
                                    width: 100, height: 100, minWidth: 100, minHeight: 100, margin: '10px 10px 0px 0px', borderRadius: 5, backgroundColor:'#ffffff',
                                    border: frame === index ? '2px solid var(--mainpink)':'1px solid var(--maindark)',
                                 }}
                                onClick={(e)=>{
                                    setFrame(parseInt(e.target.value))
                                }}
                                >

                            </button>
                        })}
                    </div> */}
                    <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                        {radiobtn_dom(
                            frame === 0,
                            () => {
                                setFrame(frame === 0 ? -1 : 0)
                            },
                            frame === 0 ? `Frame Enabled` : `Frame Disabled`,
                            { width: '100%' }
                        )}
                    </div>

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Color ', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                            <HexColorPicker
                                style={{ height: 200, width: 'calc( 100% - 20px )' }}
                                color={framecolor}
                                onChange={(e) => { setFramecolor(e) }}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: 'calc( 100% - 20px)', }}>
                                <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                <HexColorInput
                                    color={framecolor}
                                    onChange={(e) => { setFramecolor(e) }}
                                    style={{ width: '100%', borderRadius: 5, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                />
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Thickness', {})}
                            <div key={'styleborderwt' + framethickness} className='border_menu3' style={{ border: '1px solid var(--subgrey)', width: '100%', padding: 10, borderRadius: 5 }}>
                                <div
                                    className={`border_brthickthin  ${framethickness === 5 ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramethickness(framethickness === 5 ? 0 : 5) }} >
                                    <div className='border_brthickcontent' />
                                </div>
                                <div
                                    className={`border_brthickthin ${framethickness === 1 ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramethickness(framethickness === 1 ? 0 : 1) }}
                                >
                                    <div className='border_brthincontent' />
                                </div>
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Stroke', {})}
                            <div key={'styleborderwt' + framestroke} className='border_menu3' style={{ border: '1px solid var(--subgrey)', width: '100%', padding: 10, borderRadius: 5 }}>
                                <div
                                    className={`border_brthickthin ${framestroke === 'solid' ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramestroke(framestroke === 'solid' ? 'dashed' : 'solid') }}
                                >
                                    <div className='border_brthickcontent' style={{ border: '1px solid var(--maindark)' }} />
                                </div>
                                <div
                                    className={`border_brthickthin ${framestroke === 'dashed' ? 'border_styleselected' : ''}`}
                                    onClick={() => { setFramestroke(framestroke === 'dashed' ? 'solid' : 'dashed') }}
                                >
                                    <div className='border_brthincontent' style={{ border: '1px dashed var(--maindark)' }} />
                                </div>
                            </div>
                        </div>
                        : null}

                    <div style={{ height: 10 }} />

                    {frame === 0
                        ? <div className="itinerary_rightcontentsubcomp" style={{ display: 'flex', flexDirection: 'column' }} >
                            {partialtitle_dom('Frame Corner', {})}
                            <div className="Itinerary_rightcontentsubcompfsroot">
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{ borderRadius: 20, fontSize: 18 }}
                                    onClick={framecorner_dec}
                                    {...onLongPress(framecorner_dec)}
                                >
                                    -
                                </button>
                                <div className="itinerary_rightcontentnum">{framecorner}</div>
                                <button
                                    className='itinerary_rightcontentbtn'
                                    style={{ borderRadius: 20, fontSize: 18 }}
                                    onClick={framecorner_inc}
                                    {...onLongPress(framecorner_inc)}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                        : null}

                </div>
                : null,

            PRINTINGSIZE: rightcontentkey === 'PRINTINGSIZE'
                ? <div className="itinerary_rightcontentroot">
                    <div className="Rsvpexplorer_portaltitle" style={{ top: 0, position: 'absolute', width: '100%' }}>Print</div>
                    {closebtn}
                    {partialtitle_dom('Sizing', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    {inputdescribe_dom('Currently only support 1/3 A4 long sizing.', { width: 'calc( 100% - 20px)', placeContent: 'start' })}
                    <button
                        className="Itineraryedit_rightcontentrootbtn"
                        style={JSON.stringify(printingsize) === '{"width":584.666667,"height":826.666667}'
                            ? { backgroundColor: 'var(--mainpink)', color: '#ffffff' }
                            : {}}
                        onClick={() => {
                        }}>
                        Long 1/3 A4
                    </button>

                </div>
                : null

        }[rightcontentkey]}
    </div>

    // mobile not supported start
    const mobile_not_supported = device === 'MOBILE'
        ? <div id='itineraryedit_mobilebtm'>
            <div style={{ padding: 10, display: 'flex', textAlign: 'center' }}>Sorry, this feature is currently only supported on a desktop or laptop and is not available on mobile devices.</div>
            <button id='itineraryedit_mobilebtmbtn' onClick={() => props.history.push('/')}>Home</button>
        </div>
        : null

    const icon_portal = <Portalmodal
        portaltype={'commonportal'}
        open={iconportal}
        onClose={() => {
            setIconportal(false)
            setAllowedit(true)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={{ width: 320, height: 400, top: '50%', left: '50%', right: '', transform: 'translate(-50%,-50%)' }}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: 60, height: 'calc(100% - 60px )', overflowY: 'scroll' }} >
            {Object.keys(ICONNAME_ICON_MAP).map((key, index) => {
                return <div
                    key={index}
                    style={{ display: 'flex', padding: 5, margin: 5, width: 'max-content', height: 'max-content' }}
                    onClick={() => {
                        let curr_tlobjs = tlobjs.slice()
                        tlobjs[selectededitindex]['icon'].value = index === 0 ? '' : ICONNAME_ICON_MAP[key]
                        setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                        setIconportal(false)
                    }}>
                    {index === 0
                        ? ICONNAME_ICON_MAP[key]
                        : <svg className="icon" style={s_} viewBox={vb_} version={v_} xmlns={x_}>
                            <path d={ICONNAME_ICON_MAP[key]} />
                        </svg>}
                </div>
            })}
        </div>
    </Portalmodal>

    const newtemplatemodcfm = cfmaddnewtemplate
        ? <Modcfm
            onHide={() => { setCfaddnewtemplate(false) }}
            onOk={() => {
                const new_data = JSON.parse(JSON.stringify(newtemplatedata))
                setTlobjs(new_data)
                setCfaddnewtemplate(false)
                setNewtemplatedata([])
            }}
            onNo={() => { setCfaddnewtemplate(false) }}
            txt={'This action will replace your current timeline with the selected template. Please ensure that you are certain about this decision.'}
        />
        : null

    const delmodcfm = delgate
        ? <Modcfm
            onHide={() => { setDelgate(false) }}
            onOk={() => {
                let curr_tlobjs = JSON.parse(JSON.stringify(tlobjs))
                let data = {}
                if (curr_tlobjs[selectededitindex].component === 'IMAGE') {
                    let urls = []// images to remove
                    const { coupleimg1, coupleimg2, singleimg } = curr_tlobjs[selectededitindex]
                    if (coupleimg1.length !== 0) urls.push(coupleimg1)
                    if (coupleimg2.length !== 0) urls.push(coupleimg2)
                    if (singleimg.length !== 0) urls.push(singleimg)
                    curr_tlobjs.splice(selectededitindex, 1)
                    data = { _id: id, urlhandler: urlhandler, isimage: true, imageurls: urls, tlobjs: JSON.parse(JSON.stringify(curr_tlobjs)) }
                }
                else {
                    curr_tlobjs.splice(selectededitindex, 1)
                    data = { _id: id, urlhandler: urlhandler, isimage: false, imageurls: [], tlobjs: JSON.parse(JSON.stringify(curr_tlobjs)) }
                }

                let options = {
                    method: 'POST',
                    url: REMOVE_TLCOMP,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }, //need token from the web
                    data: data
                }
                axios(options).then((result) => {
                    const { data, status } = result
                    const { message } = data
                    if (status === 200) {
                        if (message === 'SUCCESS') {
                            setDelgate(false)
                            setSelectededitindex(-1)
                            setTlobjs(JSON.parse(JSON.stringify(curr_tlobjs)))
                            setRightcontentkey('NONE')
                        }
                        else {
                            refresh()
                        }
                    }
                }).catch(e => { })

            }}
            onNo={() => { setDelgate(false) }}
            txt={'Once you delete this component, there is no going back. Please be certain.'}
        />
        : null

    const download_modal = <Portalmodal
        portaltype={'commonportal'}
        open={downloadmodal}
        onClose={() => { setDownloadmodal(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title={"Download"}
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">

                <div className="Details_grp" >
                    {checkbox_dom(
                        downloadtransparent,
                        () => {
                            const txt = document.querySelector(".ce_checkboxtxt");
                            const checkbox = document.querySelector(".ce_checkbox");
                            checkbox.checked = !checkbox.checked;
                            setDownloadtransparent(!downloadtransparent)
                        },
                        'Transparent Background',
                    )}
                </div>

                <div className="Details_grp" >
                    {input_dom(
                        'File Type',
                        '.PNG',
                        '.PNG',
                        (e) => {
                        },
                        'png_id',
                        {},
                        true,
                        null,
                        {},
                        { marginLeft: 0, marginRight: 0, width: '100%', margin: 0, }
                    )}
                </div>

                <button
                    className="scedit_modalbtn"
                    style={{ marginBottom: 0, marginTop: 0, borderRadius: 5 }}
                    disabled={downloadchart}
                    onClick={() => {
                        setDownloadchart(true)
                    }}>
                    {downloadchart ? 'Generating...' : 'Download'}
                </button>
            </div>
        </div>
    </Portalmodal>

    return !loaded
        ? <Loading ht={'100%'} />
        : <div id="itineraryedit_root" >
            {topbar}
            {home_mod}
            {device === 'MOBILE'
                ? null
                : <div id='itineraryedit_btm'>
                    {left_dom}
                    {right_dom}
                </div>}
            {mobile_not_supported}
            {icon_portal}
            {delmodcfm}
            {newtemplatemodcfm}
            {notitxt && notitxt.length > 0 ? <Noti noti={notitxt} /> : null}
            {qr_modal}
            {download_modal}
        </div>
}
export default Itineraryedit